let additionalAccessoriesAccordionCollapsed = false
$.fn.datepicker
// Pattern sorting order
const PATTERN_SORT_ORDER = [
  "budaguard",
  "heelguard",
  "maxi_heelguard",
  "builders_guard",
  "megaguard",
  "traditional",
  "factory_second_traditional"
];

const GRATE_CONFIG = {
  steps: [
    {
      id: "width",
      order: 1,
      title: "Select width & depth",
      description: "Choose the overall width of the grate. Depth will appear based on your width selection.",
      field: null,
      type: "combined"
    },
    {
      id: "pattern",
      order: 2,
      title: "Select pattern",
      description: "Choose the pattern available for your chosen width and depth.",
      field: "pattern",
      type: "singleChoice",
      showThumbnails: true
    },
    {
      id: "length",
      order: 3,
      title: "Select length & quantity",
      description: "Choose your desired length and quantity. Each length variant shows pricing and quantity selector.",
      field: null,
      type: "variants"
    },
    {
      id: "accessories",
      order: 4,
      title: "Select accessories",
      description:
        "Add any accessories needed. Some configurations have no accessories available.",
      field: "accessories",
      type: "multiChoice",
      allowEmpty: true
    },
    {
      id: "summary",
      order: 5,
      title: "Summary",
      description:
        "Review your selections, check the price, and edit any step before adding to cart.",
      field: null,
      type: "summary"
    }
  ],
  fields: {
    width: {
      options: [
        { id: "125MM", label: "125mm" },
        { id: "140/150MM", label: "140/150mm", merged: ["140MM", "150MM"] },
        { id: "200MM", label: "200mm" },
        { id: "300MM", label: "300mm" }
      ]
    },
    depth: {
      optionsAll: [
        { id: "80MM", label: "80mm" },
        { id: "100MM", label: "100mm" },
        { id: "125MM", label: "125mm" },
        { id: "170MM", label: "170mm" },
        { id: "200MM", label: "200mm" },
        { id: "170/200MM", label: "170/200mm", merged: ["170MM", "200MM"] }
      ],
      byWidth: {
        "125MM": { locked: true, options: ["80MM"]},
        "140MM": { locked: true, options: ["125MM"] },
        "150MM": { locked: true, options: ["125MM"] },
        "200MM": { locked: true, options: ["170MM"] },
        "300MM": { locked: false, options: ["170/200MM"] }
      },
      imageUrls: {
        "125MM|80MM": "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/125_80.png?v=1765013128",
        "140MM|125MM": "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/140_150_125.png?v=1765634138",
        "200MM|170MM": "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/200_170.png?v=1765013851",
        "300MM|170MM": "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/300_170_200.png?v=1765634137"
      }
    },
    pattern: {
      meta: {
        traditional: {
          id: "traditional",
          label: "Traditional",
          thumbnail: "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/traditional_d954fc28-8cd7-4fc2-aaab-f8ae9c884887.png?v=1767796539",
          product_url: "https://www.buda.com.au/products/galtradboxgrate",
          tags:[
            { id: "class_b", label: "CLASS B" },
            { id: "galvanised", label: "GALVINISED" }
          ]
        },
        budaguard: {
          id: "budaguard",
          label: "Budaguard\u2122",
          thumbnail: "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/budaguard_9eb39fcd-fa00-41e3-bf01-5b841b7b2705.png?v=1767796540",
          product_url: "https://www.buda.com.au/products/galheelboxgrate",
          tags:[
            { id: "class_b", label: "CLASS B" },
            { id: "galvanised", label: "GALVINISED" }
          ]
        },
        builders_guard: {
          id: "builders_guard",
          label: "Builder's Guard\u2122",
          thumbnail: "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/buildersguard.png?v=1767796540",
          product_url: "https://www.buda.com.au/products/builders-guard-galvanised-trench-box-grates",
          tags:[
            { id: "class_b", label: "CLASS B" },
            { id: "galvanised", label: "GALVINISED" }
          ]
        },
        maxi_heelguard: {
          id: "maxi_heelguard",
          label: "Maxi Heelguard\u2122",
          thumbnail: "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/maxiheelguard.png?v=1767796540",
          product_url: "https://www.buda.com.au/products/galmaxiheelboxgrate",
          tags:[
            { id: "class_b", label: "CLASS B" },
            { id: "galvanised", label: "GALVINISED" }
          ]
        },
        heelguard: {
          id: "heelguard",
          label: "Heelguard",
          thumbnail: "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/heelguard_d98bb36e-9e08-4e79-b8f4-033afc3047cf.png?v=1767796540",
          product_url: "https://www.buda.com.au/products/ssboxgrateheelguard",
          tags:[
            { id: "class_b", label: "CLASS B" },
            { id: "stainless_steel", label: "STAINLESS STEEL" }
          ]
        },
        factory_second_traditional: {
          id: "factory_second_traditional",
          label: "Factory-Second Traditional",
          thumbnail: "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/Factorysecondtraditional.png?v=1767796539",
          product_url: "https://www.buda.com.au/products/factory-seconds-galvanised-maxi-traditional-pattern-box-grates",
          tags:[
            { id: "class_b", label: "CLASS B" },
            { id: "galvanised", label: "GALVINISED" }
          ]
        },
        megaguard: {
          id: "megaguard",
          label: "MEGAGUARD\u2122",
          thumbnail: "https://cdn.shopify.com/s/files/1/0610/1011/6826/files/megaguard.png?v=1767796540",
          product_url: "https://www.buda.com.au/products/class-d-heavy-duty-pedestrian-safe-driveway-box-grate",
          tags:[
            { id: "class_d", label: "CLASS D" },
            { id: "galvanised", label: "GALVINISED" }
          ]
        }
      },
      // allowed patterns by width/depth
      byWidthDepth: {
        "125MM|80MM": ["traditional", "budaguard"],
        "140MM|125MM": ["heelguard"],
        "150MM|125MM": [
          "traditional",
          "builders_guard",
          "maxi_heelguard",
          "budaguard"
        ],
        "200MM|170MM": [
          "factory_second_traditional",
          "traditional",
          "builders_guard",
          "maxi_heelguard",
          "budaguard",
          "heelguard",
          "megaguard"
        ],
        "300MM|170MM": ["traditional", "budaguard"],
        "300MM|200MM": ["megaguard"]
      }
    },
    length: {
      meta: {
        "1M": { id: "1M", label: "1m" },
        "1.5M": { id: "1.5M", label: "1.5m" },
        "2M": { id: "2M", label: "2m" },
        "3M": { id: "3M", label: "3m" }
      },
      // allowed lengths by width/depth/pattern
      byCombo: {
        "125MM|80MM|traditional": ["1M", "2M", "3M"],
        "125MM|80MM|budaguard": ["1M", "2M", "3M"],

        "140MM|125MM|heelguard": ["1M", "2M", "3M"],

        "150MM|125MM|traditional": ["1M", "2M", "3M"],
        "150MM|125MM|builders_guard": ["1M", "2M", "3M"],
        "150MM|125MM|maxi_heelguard": ["1M", "2M", "3M"],
        "150MM|125MM|budaguard": ["1M", "2M", "3M"],

        "200MM|170MM|megaguard": ["1.5M"],

        "200MM|170MM|factory_second_traditional": ["2M", "3M"],
        "200MM|170MM|traditional": ["2M", "3M"],
        "200MM|170MM|builders_guard": ["2M", "3M"],
        "200MM|170MM|maxi_heelguard": ["2M", "3M"],
        "200MM|170MM|budaguard": ["2M", "3M"],
        "200MM|170MM|heelguard": ["2M", "3M"],

        "300MM|170MM|traditional": ["2M", "3M"],
        "300MM|170MM|budaguard": ["2M", "3M"],

        "300MM|200MM|megaguard": ["1.5M"]
      }
    },
    tags: {
      meta: {
        class_b: { id: "class_b", label: "CLASS B" },
        class_d: { id: "class_d", label: "CLASS D" },
        galvanised: { id: "galvanised", label: "GALVINISED" },
        stainless_steel: { id: "stainless_steel", label: "STAINLESS STEEL" }
      },
      // tags by width/depth/pattern/length
      byCombo: {
        // 125 / 80 / Traditional or Budaguard / 1,2,3m -> CLASS B, GAL
        "125MM|80MM|traditional|1M": ["class_b", "galvanised"],
        "125MM|80MM|traditional|2M": ["class_b", "galvanised"],
        "125MM|80MM|traditional|3M": ["class_b", "galvanised"],
        "125MM|80MM|budaguard|1M": ["class_b", "galvanised"],
        "125MM|80MM|budaguard|2M": ["class_b", "galvanised"],
        "125MM|80MM|budaguard|3M": ["class_b", "galvanised"],

        // 140 / 125 / Heelguard
        "140MM|125MM|heelguard|1M": ["class_b", "stainless_steel"],
        "140MM|125MM|heelguard|2M": ["class_b", "stainless_steel"],
        "140MM|125MM|heelguard|3M": ["class_b", "stainless_steel"],

        // 150 / 125 / patterns
        "150MM|125MM|traditional|1M": ["class_b", "galvanised"],
        "150MM|125MM|traditional|2M": ["class_b", "galvanised"],
        "150MM|125MM|traditional|3M": ["class_b", "galvanised"],
        "150MM|125MM|builders_guard|1M": ["class_b", "galvanised"],
        "150MM|125MM|builders_guard|2M": ["class_b", "galvanised"],
        "150MM|125MM|builders_guard|3M": ["class_b", "galvanised"],
        "150MM|125MM|maxi_heelguard|1M": ["class_b", "galvanised"],
        "150MM|125MM|maxi_heelguard|2M": ["class_b", "galvanised"],
        "150MM|125MM|maxi_heelguard|3M": ["class_b", "galvanised"],
        "150MM|125MM|budaguard|1M": ["class_b", "galvanised"],
        "150MM|125MM|budaguard|2M": ["class_b", "galvanised"],
        "150MM|125MM|budaguard|3M": ["class_b", "galvanised"],

        // 200 / 170 / patterns 2m/3m (GAL)
        "200MM|170MM|factory_second_traditional|2M": [
          "class_b",
          "galvanised"
        ],
        "200MM|170MM|factory_second_traditional|3M": [
          "class_b",
          "galvanised"
        ],
        "200MM|170MM|traditional|2M": ["class_b", "galvanised"],
        "200MM|170MM|traditional|3M": ["class_b", "galvanised"],
        "200MM|170MM|builders_guard|2M": ["class_b", "galvanised"],
        "200MM|170MM|builders_guard|3M": ["class_b", "galvanised"],
        "200MM|170MM|maxi_heelguard|2M": ["class_b", "galvanised"],
        "200MM|170MM|maxi_heelguard|3M": ["class_b", "galvanised"],
        "200MM|170MM|budaguard|2M": ["class_b", "galvanised"],
        "200MM|170MM|budaguard|3M": ["class_b", "galvanised"],

        // 200 / 170 / Heelguard 2m/3m (STAINLESS)
        "200MM|170MM|heelguard|2M": ["class_b", "stainless_steel"],
        "200MM|170MM|heelguard|3M": ["class_b", "stainless_steel"],

        // 200 / 170 / MEGAGUARD 1.5m (CLASS D)
        "200MM|170MM|megaguard|1.5M": ["class_d", "galvanised"],

        // 300 / 170 / Traditional & Budaguard 2m/3m (GAL)
        "300MM|170MM|traditional|2M": ["class_b", "galvanised"],
        "300MM|170MM|traditional|3M": ["class_b", "galvanised"],
        "300MM|170MM|budaguard|2M": ["class_b", "galvanised"],
        "300MM|170MM|budaguard|3M": ["class_b", "galvanised"],

        // 300 / 200 / MEGAGUARD 1.5m (CLASS D)
        "300MM|200MM|megaguard|1.5M": ["class_d", "galvanised"]
      }
    },
    accessories: {
      meta: {
        end_caps: { id: "end_caps", label: "END CAPS" },
        joiner: { id: "joiner", label: "JOINER" },
        base_outlet: { id: "base_outlet", label: "BASE OUTLET" },
        end_outlet: { id: "end_outlet", label: "END OUTLET" },
        corner_90: { id: "corner_90", label: "90 DEGREE CORNER JOINER"},
        screws: { id: "screws", label: "SCREWS" },
        fast_set_concrete: { id: "fast_set_concrete", label: "FAST SET CONCRETE"},
        concretors_tape: { id: "concretors_tape",label: "CONCRETORS TAPE"},
        outlet_150_plate: { id: "outlet_150_plate",label: "OUTLET TO SUIT 150MM PLATE"},
        gal_strainer: { id: "gal_strainer", label: "GAL STRAINER" }
      },
      // accessories based on width & pattern (pattern can be "*" for "all")
      byWidthPattern: {
        // 125mm – all patterns
        "125MM|*": [
          "end_caps",
          "joiner",
          "base_outlet",
          "corner_90",
          "screws",
          "fast_set_concrete",
          "concretors_tape"
        ],
        // 140mm – all patterns
        "140MM|*": [
          "end_caps",
          "joiner",
          "base_outlet",
          "end_outlet",
          "fast_set_concrete",
          "concretors_tape"
        ],
        // 150mm – all patterns
        "150MM|*": [
          "end_caps",
          "joiner",
          "base_outlet",
          "end_outlet",
          "corner_90",
          "screws",
          "fast_set_concrete",
          "concretors_tape",
          "gal_strainer"
        ],
        // 200mm – Factory-Second Traditional : no accessories
        "200MM|factory_second_traditional": [
          "end_caps",
          "joiner",
          "base_outlet",
          "end_outlet",
          "outlet_150_plate",
          "corner_90",
          "screws",
          "fast_set_concrete",
          "concretors_tape",
          "gal_strainer"
        ],
        // 200mm – Traditional, Builder's Guard, Maxi Heelguard, Budaguard, MEGAGUARD
        "200MM|traditional": [
          "end_caps",
          "joiner",
          "base_outlet",
          "end_outlet",
          "outlet_150_plate",
          "corner_90",
          "screws",
          "fast_set_concrete",
          "concretors_tape",
          "gal_strainer"
        ],
        "200MM|builders_guard": [
          "end_caps",
          "joiner",
          "base_outlet",
          "end_outlet",
          "outlet_150_plate",
          "corner_90",
          "screws",
          "fast_set_concrete",
          "concretors_tape",
          "gal_strainer"
        ],
        "200MM|maxi_heelguard": [
          "end_caps",
          "joiner",
          "base_outlet",
          "end_outlet",
          "outlet_150_plate",
          "corner_90",
          "screws",
          "fast_set_concrete",
          "concretors_tape",
          "gal_strainer"
        ],
        "200MM|budaguard": [
          "end_caps",
          "joiner",
          "base_outlet",
          "end_outlet",
          "outlet_150_plate",
          "corner_90",
          "screws",
          "fast_set_concrete",
          "concretors_tape",
          "gal_strainer"
        ],
        "200MM|megaguard": [
          "end_caps",
          "joiner",
          "base_outlet",
          "end_outlet",
          "outlet_150_plate",
          "corner_90",
          "screws",
          "fast_set_concrete",
          "concretors_tape",
          "gal_strainer"
        ],
        // 200mm – Heelguard
        "200MM|heelguard": [
          "end_caps",
          "joiner",
          "base_outlet",
          "end_outlet",
          "fast_set_concrete",
          "concretors_tape"
        ],
        // 300mm – all patterns
        "300MM|*": [
          "end_caps",
          "joiner",
          "base_outlet",
          "end_outlet",
          "outlet_150_plate",
          "corner_90",
          "screws",
          "fast_set_concrete",
          "concretors_tape",
          "gal_strainer"
        ]
      }
    }
  },
  // Pricing per valid combination
  pricingRules: [
    {
      width: "125MM",
      depth: "80MM",
      pattern: "traditional",
      lengths: ["1M", "2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 135.0
    },
    {
      width: "125MM",
      depth: "80MM",
      pattern: "budaguard",
      lengths: ["1M", "2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 206.0
    },
    {
      width: "140MM",
      depth: "125MM",
      pattern: "heelguard",
      lengths: ["1M", "2M", "3M"],
      tags: ["class_b", "stainless_steel"],
      price: 440.0
    },
    {
      width: "150MM",
      depth: "125MM",
      pattern: "traditional",
      lengths: ["1M", "2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 165.0
    },
    {
      width: "150MM",
      depth: "125MM",
      pattern: "builders_guard",
      lengths: ["1M", "2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 203.0
    },
    {
      width: "150MM",
      depth: "125MM",
      pattern: "maxi_heelguard",
      lengths: ["1M", "2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 251.0
    },
    {
      width: "150MM",
      depth: "125MM",
      pattern: "budaguard",
      lengths: ["1M", "2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 285.0
    },
    {
      width: "200MM",
      depth: "170MM",
      pattern: "factory_second_traditional",
      lengths: ["2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 164.0
    },
    {
      width: "200MM",
      depth: "170MM",
      pattern: "traditional",
      lengths: ["2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 225.0
    },
    {
      width: "200MM",
      depth: "170MM",
      pattern: "builders_guard",
      lengths: ["2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 220.0
    },
    {
      width: "200MM",
      depth: "170MM",
      pattern: "maxi_heelguard",
      lengths: ["2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 283.0
    },
    {
      width: "200MM",
      depth: "170MM",
      pattern: "budaguard",
      lengths: ["2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 316.0
    },
    {
      width: "200MM",
      depth: "170MM",
      pattern: "heelguard",
      lengths: ["2M", "3M"],
      tags: ["class_b", "stainless_steel"],
      price: 577.5
    },
    {
      width: "200MM",
      depth: "170MM",
      pattern: "megaguard",
      lengths: ["1.5M"],
      tags: ["class_d", "galvanised"],
      price: 333.33
    },
    {
      width: "300MM",
      depth: "170MM",
      pattern: "traditional",
      lengths: ["2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 263.5
    },
    {
      width: "300MM",
      depth: "170MM",
      pattern: "budaguard",
      lengths: ["2M", "3M"],
      tags: ["class_b", "galvanised"],
      price: 389.0
    },
    {
      width: "300MM",
      depth: "200MM",
      pattern: "megaguard",
      lengths: ["1.5M"],
      tags: ["class_d", "galvanised"],
      price: 440.0
    }
  ]
};
  
// Variants Object
const PRODUCT_VARIANT_MAP = {
  patterns: {
    traditional: {
      product_id: 9109789343962,
      variants: {
        "125MM|80MM|1M": 47202315895002,
        "125MM|80MM|2M": 47202315927770,
        "125MM|80MM|3M": 47202315960538,
        "150MM|125MM|1M": 47202319597786,
        "150MM|125MM|2M": 47202319728858,
        "150MM|125MM|3M": 47202320089306,
        "200MM|170MM|2M": 47202319859930,
        "200MM|170MM|3M": 47202333294810,
        "300MM|170MM|2M": 47202332868826,
        "300MM|170MM|3M": 47202320318682
      }
    },
    budaguard: {
      product_id: 9141751709914,
      variants: {
        "125MM|80MM|1M": 47344284270810,
        "125MM|80MM|2M": 47344284336346,
        "125MM|80MM|3M": 47344284467418,
        "150MM|125MM|1M": 47344284303578,
        "150MM|125MM|2M": 47344284369114,
        "150MM|125MM|3M": 47344284500186,
        "200MM|170MM|2M": 47344284401882,
        "200MM|170MM|3M": 47344284532954,
        "300MM|170MM|2M": 47344284434650,
        "300MM|170MM|3M": 47344284565722
      }
    },
    builders_guard: {
      product_id: 9110301245658,
      variants: {
        "150MM|125MM|1M": 47206645629146,
        "150MM|125MM|2M": 47206645661914,
        "150MM|125MM|3M": 47206645727450,
        "200MM|170MM|2M": 47206645694682,
        "200MM|170MM|3M": 47206645760218
      }
    },
    maxi_heelguard: {
      product_id: 9110310125786,
      variants: {
        "150MM|125MM|1M": 47206659260634,
        "150MM|125MM|2M": 47206659293402,
        "150MM|125MM|3M": 47206659358938,
        "200MM|170MM|2M": 47206659326170,
        "200MM|170MM|3M": 47206659391706
      }
    },
    heelguard: {
      product_id: 9110287581402,
      variants: {
        "140MM|125MM|1M": 47206619283674,
        "140MM|125MM|2M": 47206619316442,
        "140MM|125MM|3M": 47206619381978,
        "200MM|170MM|2M": 47206619349210,
        "200MM|170MM|3M": 47206619414746
      }
    },
    factory_second_traditional: {
      product_id: 9110329819354,
      variants: {
        "200MM|170MM|2M": 47206674039002,
        "200MM|170MM|3M": 47206674071770
      }
    },
    megaguard: {
      product_id: 9110332080346,
      variants: {
        "200MM|170MM|1.5M": 47206679314650,
        "300MM|200MM|1.5M": 47206679412954
      }
    }
  },
};

// --- Accessory Configuration ---
const ACCESSORY_CONFIG = {
  patternTags: {
    traditional: "galvanised",
    budaguard: "galvanised",
    heelguard: "stainless_steel",
    builders_guard: "galvanised",
    maxi_heelguard: "galvanised",
    factory_second_traditional: "galvanised",
    megaguard: "galvanised"
  },
  
  byTag: {
    galvanised: {
      traditional: {
        "125MM|80MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337681114, price: 16.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336272090, price: 16.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333585114, price: 30.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148222170, price: 46.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
        "150MM|125MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337713882, price: 20.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336304858, price: 20.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333617882, price: 35.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "End Outlet", accessory: "end_outlet", variant_id: 47217722949850, price: 35.00, img_url: "https://www.buda.com.au/cdn/shop/files/2_4ecd5a4d-9d8d-4f5c-be27-4f4c8fabd94d.png?v=1765756606&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148254938, price: 54.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
        "200MM|170MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337746650, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336337626, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333650650, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "End Outlet", accessory: "end_outlet", variant_id: 47217722982618, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_9fb1a0d9-169d-4645-90dd-17bdde360bca.png?v=1765756769&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148287706, price: 60.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
        "300MM|170MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337779418, price: 27.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336370394, price: 27.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333683418, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148320474, price: 72.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" }
        ]
      },
      budaguard: {
        "125MM|80MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337681114, price: 16.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336272090, price: 16.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333585114, price: 30.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148222170, price: 46.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
        "150MM|125MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337713882, price: 20.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336304858, price: 20.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333617882, price: 35.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "End Outlet", accessory: "end_outlet", variant_id: 47217722949850, price: 35.00, img_url: "https://www.buda.com.au/cdn/shop/files/2_4ecd5a4d-9d8d-4f5c-be27-4f4c8fabd94d.png?v=1765756606&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148254938, price: 54.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
        "200MM|170MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337746650, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336337626, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333650650, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "End Outlet", accessory: "end_outlet", variant_id: 47217722982618, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_9fb1a0d9-169d-4645-90dd-17bdde360bca.png?v=1765756769&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148287706, price: 60.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
        "300MM|170MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337779418, price: 27.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336370394, price: 27.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333683418, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148320474, price: 72.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" }
        ]
      },
      builders_guard: {
        "150MM|125MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337713882, price: 20.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336304858, price: 20.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333617882, price: 35.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "End Outlet", accessory: "end_outlet", variant_id: 47217722949850, price: 35.00, img_url: "https://www.buda.com.au/cdn/shop/files/2_4ecd5a4d-9d8d-4f5c-be27-4f4c8fabd94d.png?v=1765756606&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148254938, price: 54.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
        "200MM|170MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337746650, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336337626, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333650650, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "End Outlet", accessory: "end_outlet", variant_id: 47217722982618, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_9fb1a0d9-169d-4645-90dd-17bdde360bca.png?v=1765756769&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148287706, price: 60.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
      },
      maxi_heelguard: {
        "150MM|125MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337713882, price: 20.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336304858, price: 20.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333617882, price: 35.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "End Outlet", accessory: "end_outlet", variant_id: 47217722949850, price: 35.00, img_url: "https://www.buda.com.au/cdn/shop/files/2_4ecd5a4d-9d8d-4f5c-be27-4f4c8fabd94d.png?v=1765756606&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148254938, price: 54.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
        "200MM|170MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337746650, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336337626, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333650650, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "End Outlet", accessory: "end_outlet", variant_id: 47217722982618, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_9fb1a0d9-169d-4645-90dd-17bdde360bca.png?v=1765756769&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148287706, price: 60.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
      },
      factory_second_traditional: {
        "200MM|170MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337746650, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336337626, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333650650, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "End Outlet", accessory: "end_outlet", variant_id: 47217722982618, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_9fb1a0d9-169d-4645-90dd-17bdde360bca.png?v=1765756769&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148287706, price: 60.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
      },
      megaguard: {
        "200MM|170MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337746650, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336337626, price: 23.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333650650, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "End Outlet", accessory: "end_outlet", variant_id: 47217722982618, price: 36.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_9fb1a0d9-169d-4645-90dd-17bdde360bca.png?v=1765756769&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148287706, price: 60.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        ],
        "300MM|170MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039337779418, price: 27.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-end-caps-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Joiners", accessory: "joiners", variant_id: 42039336370394, price: 27.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039333683418, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-outlets-galvanised-steel.png?v=1689061397&width=1080" },
          { name: "150mm Outlet Plate", accessory: "outlet_plate", variant_id: 47239899971802, price: 42.00, img_url: "https://www.buda.com.au/cdn/shop/files/1_a7e7073b-a3d3-4f2c-8d1a-d954adbd2930.png?v=1766451087&width=1080" },
          { name: "Screws to Suit Accessories (25 PK)",accessory: "screws",variant_id: 46421943779546,price: 7.70,img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"},
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148320474, price: 72.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
          // { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" }
        ]
      }
    },
    stainless_steel: {
      heelguard: {
        "140MM|125MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039340040410, price: 24.26, img_url: "https://www.buda.com.au/cdn/shop/files/end-caps-stainless-steel-3.png?v=1689061409&width=1080" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039388733658, price: 57.75, img_url: "https://www.buda.com.au/cdn/shop/files/stainless-steel-water-outlet-flange-4.png?v=1689061411&width=1080" },
          { name: "End Outlets", accessory: "end_outlets", variant_id: 42039388766426, price: 57.75, img_url: "https://www.buda.com.au/cdn/shop/files/stainless-steel-water-outlet-flange-3.png?v=1689061409&width=1080" },
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "Joiners", accessory: "joiners", variant_id: 42039336370394, price: 27.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
        ],
        "200MM|170MM": [
          { name: "End Caps", accessory: "end_caps", variant_id: 42039340073178, price: 29.43, img_url: "https://www.buda.com.au/cdn/shop/files/end-caps-stainless-steel-5.png?v=1689061414&width=1080" },
          { name: "Base Outlets", accessory: "base_outlets", variant_id: 42039388799194, price: 69.30, img_url: "https://www.buda.com.au/cdn/shop/files/stainless-steel-water-outlet-flange-5.png?v=1689061414&width=1080" },
          // { name: "End Outlets", accessory: "end_outlets", variant_id: 42039388766426, price: 57.75, img_url: "https://www.buda.com.au/cdn/shop/files/stainless-steel-water-outlet-flange-3.png?v=1689061409&width=1080" },
          { name: "Concretor\u0027s Tape",accessory: "concretors_tape",variant_id: 44649473638618,price: 15.00,img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"},
          { name: "FAST SET CONCRETE - 20KG BAG",accessory: "fast_set_concrete",variant_id: 47012049158362,price: 14.42,img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"},
          // { name: "Joiners", accessory: "joiners", variant_id: 42039336370394, price: 27.00, img_url: "https://www.buda.com.au/cdn/shop/files/box-grate-joiners-galvanised-steel.png?v=1689061404&width=360" },
        ]
      }
    }
  },
  
  universal: {
    galvanised: {
      "125MM|80MM": [
        { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148222170, price: 46.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
        { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        { name: "125mm Cutting Discs (10 PK)", accessory: "cutting_disc_for_steel", variant_id: 43912762392794, price: 29.99, img_url: "https://www.buda.com.au/cdn/shop/files/cutting-disc-125-x-1mm-silver-series-trade-tin-pk-10--1.jpg?v=1689061553&width=1080" },
        { name: "Universal Arbor for Holesaw", accessory: "universal_arbor_for_holesaw", variant_id: 43912755118298, price: 39.58, img_url: "https://www.buda.com.au/cdn/shop/files/large-arbor-to-suit-32-250mm-holesaws.jpg?v=1689061553&width=1080" },
        { name: "Holesaw", accessory: "holesaw", variant_id: 43921700683994, price: 30.03, img_url: "https://www.buda.com.au/cdn/shop/files/holesaw-1.jpg?v=1689061553&width=1080" },
        { name: "Hex Key Set", accessory: "hex_key_set", variant_id: 45521029759194, price: 13.84, img_url: "https://www.buda.com.au/cdn/shop/files/AllenKeysfront_5e0e71f5-b6bc-48dd-8ee3-d855c1c6e3d7.png" },
      ],
      "150MM|125MM": [
        { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148254938, price: 54.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
        { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        { name: "125mm Cutting Discs (10 PK)", accessory: "cutting_disc_for_steel", variant_id: 43912762392794, price: 29.99, img_url: "https://www.buda.com.au/cdn/shop/files/cutting-disc-125-x-1mm-silver-series-trade-tin-pk-10--1.jpg?v=1689061553&width=1080" },
        { name: "Universal Arbor for Holesaw", accessory: "universal_arbor_for_holesaw", variant_id: 43912755118298, price: 39.58, img_url: "https://www.buda.com.au/cdn/shop/files/large-arbor-to-suit-32-250mm-holesaws.jpg?v=1689061553&width=1080" },
        { name: "Holesaw", accessory: "holesaw", variant_id: 43921700683994, price: 30.03, img_url: "https://www.buda.com.au/cdn/shop/files/holesaw-1.jpg?v=1689061553&width=1080" },
        { name: "Hex Key Set", accessory: "hex_key_set", variant_id: 45521029759194, price: 13.84, img_url: "https://www.buda.com.au/cdn/shop/files/AllenKeysfront_5e0e71f5-b6bc-48dd-8ee3-d855c1c6e3d7.png" },
      ],
      "200MM|170MM": [
        { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148287706, price: 60.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
        { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        { name: "125mm Cutting Discs (10 PK)", accessory: "cutting_disc_for_steel", variant_id: 43912762392794, price: 29.99, img_url: "https://www.buda.com.au/cdn/shop/files/cutting-disc-125-x-1mm-silver-series-trade-tin-pk-10--1.jpg?v=1689061553&width=1080" },
        { name: "Universal Arbor for Holesaw", accessory: "universal_arbor_for_holesaw", variant_id: 43912755118298, price: 39.58, img_url: "https://www.buda.com.au/cdn/shop/files/large-arbor-to-suit-32-250mm-holesaws.jpg?v=1689061553&width=1080" },
        { name: "Holesaw", accessory: "holesaw", variant_id: 43921700683994, price: 30.03, img_url: "https://www.buda.com.au/cdn/shop/files/holesaw-1.jpg?v=1689061553&width=1080" },
        { name: "Hex Key Set", accessory: "hex_key_set", variant_id: 45521029759194, price: 13.84, img_url: "https://www.buda.com.au/cdn/shop/files/AllenKeysfront_5e0e71f5-b6bc-48dd-8ee3-d855c1c6e3d7.png" },
      ],
      "300MM|170MM": [
        { name: "90 Degree Joiner", accessory: "corner_90", variant_id: 43976148320474, price: 72.00, img_url: "https://www.buda.com.au/cdn/shop/files/90-degree-joiner-to-suit-galvanised-box-grate.png?v=1689061597&width=1080" },
        { name: "Galvanised Strainer", accessory: "gal_strainer", variant_id: 45521030643930, price: 27.50, img_url: "https://www.buda.com.au/cdn/shop/files/GalvanisedStrainerfront.png?v=1720754366&width=1080" },
        { name: "125mm Cutting Discs (10 PK)", accessory: "cutting_disc_for_steel", variant_id: 43912762392794, price: 29.99, img_url: "https://www.buda.com.au/cdn/shop/files/cutting-disc-125-x-1mm-silver-series-trade-tin-pk-10--1.jpg?v=1689061553&width=1080" },
        { name: "Universal Arbor for Holesaw", accessory: "universal_arbor_for_holesaw", variant_id: 43912755118298, price: 39.58, img_url: "https://www.buda.com.au/cdn/shop/files/large-arbor-to-suit-32-250mm-holesaws.jpg?v=1689061553&width=1080" },
        { name: "Holesaw", accessory: "holesaw", variant_id: 43921700683994, price: 30.03, img_url: "https://www.buda.com.au/cdn/shop/files/holesaw-1.jpg?v=1689061553&width=1080" },
        { name: "Hex Key Set", accessory: "hex_key_set", variant_id: 45521029759194, price: 13.84, img_url: "https://www.buda.com.au/cdn/shop/files/AllenKeysfront_5e0e71f5-b6bc-48dd-8ee3-d855c1c6e3d7.png" },
      ]
    },
    stainless_steel: {
      "140MM|125MM": [
        { name: "125mm Cutting Discs (10 PK)", accessory: "cutting_disc_for_steel", variant_id: 43912762392794, price: 29.99, img_url: "https://www.buda.com.au/cdn/shop/files/cutting-disc-125-x-1mm-silver-series-trade-tin-pk-10--1.jpg?v=1689061553&width=1080" },
        { name: "Universal Arbor for Holesaw", accessory: "universal_arbor_for_holesaw", variant_id: 43912755118298, price: 39.58, img_url: "https://www.buda.com.au/cdn/shop/files/large-arbor-to-suit-32-250mm-holesaws.jpg?v=1689061553&width=1080" },
        { name: "Holesaw", accessory: "holesaw", variant_id: 43921700683994, price: 30.03, img_url: "https://www.buda.com.au/cdn/shop/files/holesaw-1.jpg?v=1689061553&width=1080" },
        { name: "Hex Key Set", accessory: "hex_key_set", variant_id: 45521029759194, price: 13.84, img_url: "https://www.buda.com.au/cdn/shop/files/AllenKeysfront_5e0e71f5-b6bc-48dd-8ee3-d855c1c6e3d7.png" },
      ],
      "200MM|170MM": [
        { name: "125mm Cutting Discs (10 PK)", accessory: "cutting_disc_for_steel", variant_id: 43912762392794, price: 29.99, img_url: "https://www.buda.com.au/cdn/shop/files/cutting-disc-125-x-1mm-silver-series-trade-tin-pk-10--1.jpg?v=1689061553&width=1080" },
        { name: "Universal Arbor for Holesaw", accessory: "universal_arbor_for_holesaw", variant_id: 43912755118298, price: 39.58, img_url: "https://www.buda.com.au/cdn/shop/files/large-arbor-to-suit-32-250mm-holesaws.jpg?v=1689061553&width=1080" },
        { name: "Holesaw", accessory: "holesaw", variant_id: 43921700683994, price: 30.03, img_url: "https://www.buda.com.au/cdn/shop/files/holesaw-1.jpg?v=1689061553&width=1080" },
        { name: "Hex Key Set", accessory: "hex_key_set", variant_id: 45521029759194, price: 13.84, img_url: "https://www.buda.com.au/cdn/shop/files/AllenKeysfront_5e0e71f5-b6bc-48dd-8ee3-d855c1c6e3d7.png" },
        ]
    }
  
    // screws: {
    //   name: "Screws to Suit Accessories",
    //   accessory: "screws",
    //   variant_id: "46421943779546",
    //   price: 7.70,
    //   img_url: "https://www.buda.com.au/cdn/shop/files/s-l1200.jpg?v=1746057615&width=1080"
    // },
    // concretors_tape: {
    //   name: "Concretor\u0027s Tape",
    //   accessory: "concretors_tape",
    //   variant_id: "44649473638618",
    //   price: 15.00,
    //   img_url: "https://www.buda.com.au/cdn/shop/files/IMG_6556.png?v=1710275144&width=1080"
    // },
    // fast_set_concrete: {
    //   name: "FAST SET CONCRETE - 20KG BAG",
    //   accessory: "fast_set_concrete",
    //   variant_id: "47012049158362",
    //   price: 14.42,
    //   img_url: "https://www.buda.com.au/cdn/shop/files/1_5c175bea-29b4-416c-b002-69c20772f03e.png?v=1760591222&width=1080"
    // }
  }
};

// --- Holesaw Variants Configuration ---
const HOLESAW_VARIANTS = {
  "holesaw": {
    variants: [
      { id: "50mm", label: "50mm", variantId: 43921700683994,price:30.03 },
      { id: "68mm", label: "68mm", variantId: 43921700716762,price:32.98 },
      { id: "76mm", label: "76mm", variantId: 43921700749530,price:38.48 },
      { id: "83mm", label: "83mm", variantId: 43921700815066,price:39.44 },
      { id: "95mm", label: "95mm", variantId: 43921700847834,price:45.98 },
    ],
    baseAccessoryId: "holesaw"
  }
};

// --- State ---

const state = {
  selections: {
    width: null,
    depth: null,
    pattern: null,
    accessories: []
  },
  groupedWidth: null, // Track the original grouped width value
  groupedDepth: null, // Track the original grouped depth value
  addedLengths: [],
  addedAccessories: [],
  holesawVariantSelected: "50mm" // Default to Variant A
};

const summaryTotalEl = document.querySelector("[data-summary-total]");
const summaryListEl = document.querySelector("[data-summary-list]");
const sidebarErrorEl = document.getElementById("sidebar-pricing-error");
const sidebarAddBtn = document.getElementById("sidebar-add-btn");
const sidebarSaveBtn = document.getElementById("sidebar-save-btn");
const sidebarSaveAndContinueBtn = document.getElementById("sidebar-save-and-continue-btn");
const visualdiagram = document.querySelector(".visual-diagram");
// const visualDepth = document.querySelector("[data-visual-depth]");

// Utility helpers
function resetAllSelections() {
  state.selections = {
    width: null,
    depth: null,
    pattern: null,
    accessories: []
  };
  state.groupedWidth = null;
  state.groupedDepth = null;
  state.addedLengths = [];
  state.addedAccessories = [];
  state.holesawVariantSelected = "50mm";
  
  // Then update UI to reflect the reset
  applyDerivedSelectionsFromStepIndex(-1);
  renderAllSteps();
  renderSidebar();
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}

function formatCurrency(amount) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(amount);
}

function getPatternMeta(id) {
  return GRATE_CONFIG.fields.pattern.meta[id];
}

function getAccessoryMeta(id) {
  return GRATE_CONFIG.fields.accessories.meta[id];
}

function getPatternTag(patternId) {
  return ACCESSORY_CONFIG.patternTags[patternId] || null;
}

// Holesaw variant helper functions
function getHolesawVariantInfo(variantId) {
  const variants = HOLESAW_VARIANTS.holesaw.variants;
  return variants.find(v => v.id === variantId);
}

function getHolesawVariantQuantity(variantId) {
  const item = state.addedAccessories.find(
    a => a.accessory === "holesaw" && a.variantId === variantId
  );
  return item ? item.quantity : 0;
}

function getAccessoriesForSelection(pattern, width, depth) {
  const tag = getPatternTag(pattern);
  if (!tag) return { tagBasedAccessories: [], universalAccessories: [] };
  
  // Build arrays for accessories lookup - handle grouped widths/depths
  let widthsToCheck = [width];
  let depthsToCheck = [depth];
  
  // If grouped width, add all concrete widths
  if (state.groupedWidth) {
    const groupedWidthOpt = GRATE_CONFIG.fields.width.options.find(
      (o) => o.id === state.groupedWidth
    );
    if (groupedWidthOpt && groupedWidthOpt.merged) {
      widthsToCheck = groupedWidthOpt.merged;
    }
  }
  
  // If grouped depth, add all concrete depths
  if (state.groupedDepth) {
    const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
      (d) => d.id === state.groupedDepth
    );
    if (groupedDepthOpt && groupedDepthOpt.merged) {
      depthsToCheck = groupedDepthOpt.merged;
    }
  }
  
  // Get tag-based accessories for ALL width/depth combinations
  let accessoriesSet = new Set();
  widthsToCheck.forEach((w) => {
    depthsToCheck.forEach((d) => {
      const widthDepthKey = `${w}|${d}`;
      if (ACCESSORY_CONFIG.byTag[tag] && ACCESSORY_CONFIG.byTag[tag][pattern]) {
        const accs = ACCESSORY_CONFIG.byTag[tag][pattern][widthDepthKey] || [];
        accs.forEach(acc => {
          // Use JSON stringified version to avoid duplicate objects
          accessoriesSet.add(JSON.stringify(acc));
        });
      }
    });
  });
  
  // Convert back from JSON strings to objects
  const tagBasedAccessories = Array.from(accessoriesSet).map(acc => JSON.parse(acc));
  
  // Get universal accessories for the tag and width|depth combination
  let universalAccessoriesSet = new Set();
  widthsToCheck.forEach((w) => {
    depthsToCheck.forEach((d) => {
      const widthDepthKey = `${w}|${d}`;
      
      // Check if universal accessories exist for this tag
      if (ACCESSORY_CONFIG.universal[tag]) {
        const accs = ACCESSORY_CONFIG.universal[tag][widthDepthKey] || [];
        accs.forEach(acc => {
          universalAccessoriesSet.add(JSON.stringify(acc));
        });
      }
    });
  });
  
  // Convert back from JSON strings to objects
  const universalAccessories = Array.from(universalAccessoriesSet).map(acc => JSON.parse(acc));
  
  return { 
    tagBasedAccessories: tagBasedAccessories,
    universalAccessories: universalAccessories
  };
}

function getConcreteDepthForPricing(depth) {
  // If depth is grouped/merged, return the first concrete depth
  // Otherwise return the depth as-is
  if (state.groupedDepth === depth) {
    const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
      (d) => d.id === state.groupedDepth
    );
    if (groupedDepthOpt && groupedDepthOpt.merged && groupedDepthOpt.merged.length > 0) {
      return groupedDepthOpt.merged[0];
    }
  }
  return depth;
}

function getPerMeterPriceForPattern(width, depth, pattern) {
  // width and depth can be strings OR arrays
  // If array, try to find a matching pricing rule for ANY combination
  
  const widths = Array.isArray(width) ? width : [width];
  const depths = Array.isArray(depth) ? depth : [depth];
  
  // Try to find a matching pricing rule
  for (let w of widths) {
    for (let d of depths) {
      const rule = GRATE_CONFIG.pricingRules.find(r =>
        r.width === w && r.depth === d && r.pattern === pattern
      );
      if (rule) {
        // console.log("Pricing rule found for", w, d, pattern, ":", rule);
        return rule.price;
      }
    }
  }
  
  // console.log("No pricing rule found for", width, depth, pattern);
  return null;
}

function calculateLengthVariantPrice(lengthId, perMeterPrice) {
  if (!perMeterPrice) return null;
  // Extract numeric value from lengthId (e.g., "2M" -> 2, "1.5M" -> 1.5)
  const match = lengthId.match(/^([\d.]+)M$/);
  if (!match) return null;
  const lengthValue = parseFloat(match[1]);
  return perMeterPrice * lengthValue;
}

function arraysEqualAsSets(a, b) {
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  const sa = new Set(a);
  for (const v of b) {
    if (!sa.has(v)) return false;
  }
  return true;
}

function keyWidthDepthPattern(width, depth, pattern) {
  return `${width}|${depth}|${pattern}`;
}
function mergeObjects(obj1, obj2) {
  const result = { ...obj1 };

  for (const key in obj2) {
    if (key in result) {
      const v1 = result[key];
      const v2 = obj2[key];

      if (Array.isArray(v1) && Array.isArray(v2)) {
        result[key] = [...v1, ...v2];
      } 
      else if (typeof v1 === 'number' && typeof v2 === 'number') {
        result[key] = v1 + v2;
      } 
      else if (
        typeof v1 === 'object' &&
        typeof v2 === 'object' &&
        !Array.isArray(v1)
      ) {
        result[key] = mergeObjects(v1, v2);
      } 
      else {
        result[key] = v2;
      }
    } else {
      result[key] = obj2[key];
    }
  }

  return result;
}
function mergeAccessoryConfigs() {
    let byTagKeysArray = Object.keys(ACCESSORY_CONFIG.byTag.galvanised)
    let universalKeysArray = Object.keys(ACCESSORY_CONFIG.universal.galvanised)
    Object.keys(ACCESSORY_CONFIG.byTag.stainless_steel).forEach(v => byTagKeysArray.push(v))
    Object.keys(ACCESSORY_CONFIG.universal.stainless_steel).forEach(v => universalKeysArray.push(v))
    byTagKeysArray = new Set(byTagKeysArray)
    universalKeysArray = new Set(universalKeysArray)
    let byTagMerged = mergeObjects(ACCESSORY_CONFIG.byTag.galvanised,ACCESSORY_CONFIG.byTag.stainless_steel)
    let universalMerged = mergeObjects(ACCESSORY_CONFIG.universal.galvanised,ACCESSORY_CONFIG.universal.stainless_steel)
    universalMerged['holsaw'] = []
    HOLESAW_VARIANTS.holesaw.variants.forEach(v => universalMerged.holsaw.push({'variant_id':v.variantId}))
    let accessoriesVariantsIds = []
    byTagKeysArray.forEach(v => {
        let wdarray = Object.keys(byTagMerged[v])
        wdarray.forEach(vv => {
            byTagMerged[v][vv].forEach(vvv => {
                accessoriesVariantsIds.push(vvv.variant_id)
                console.log('variantid',vvv.variant_id)
            })
        })
    })
    universalKeysArray.forEach(v => {
        let wdarray = universalMerged[v]
        wdarray.forEach(vv => {
            accessoriesVariantsIds.push(vv.variant_id)
            console.log('variantiddd',vv.variant_id)
        })
    })
    console.log('accessoriesVariantsIds',accessoriesVariantsIds)
    accessoriesVariantsIds = new Set(accessoriesVariantsIds);
    return accessoriesVariantsIds
}
function mergeProductsConfigs(){
  let productsPattrensKeys = Object.keys(PRODUCT_VARIANT_MAP.patterns)
  let productVariants = []
  productsPattrensKeys.forEach(v => {
      let wDArray = Object.keys(PRODUCT_VARIANT_MAP.patterns[v].variants)
      wDArray.forEach(vv => productVariants.push(PRODUCT_VARIANT_MAP.patterns[v].variants[vv]))
  })
  productVariants = new Set(productVariants)
  return productVariants
}

// --- Logic: available options per step ---

function getAvailableOptionsForStep(step, selections) {
  const { width, depth, pattern, length } = selections;

  switch (step.id) {
    case "width": {
      return GRATE_CONFIG.fields.width.options.slice();
    }
    case "depth": {
      if (!width) return [];
      const rule = GRATE_CONFIG.fields.depth.byWidth[width];
      if (!rule) return [];
      return rule.options.map((id) => {
        const base = GRATE_CONFIG.fields.depth.optionsAll.find(
          (d) => d.id === id
        );
        return {
          ...base,
          locked: rule.locked
        };
      });
    }
    case "pattern": {
      if (!width || !depth) return [];
      
      // Get patterns and track which concrete width/depth each comes from
      let patternMap = {}; // { patternId: { meta, concreteWidth, concreteDepth } }
      
      // Determine actual widths to use
      let widthsToCheck = [width];
      if (state.groupedWidth) {
        const groupedWidthOpt = GRATE_CONFIG.fields.width.options.find(
          (o) => o.id === state.groupedWidth
        );
        if (groupedWidthOpt && groupedWidthOpt.merged) {
          widthsToCheck = groupedWidthOpt.merged;
        }
      }
      
      // Determine actual depths to use
      let depthsToCheck = [depth];
      if (state.groupedDepth) {
        const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
          (d) => d.id === state.groupedDepth
        );
        if (groupedDepthOpt && groupedDepthOpt.merged) {
          depthsToCheck = groupedDepthOpt.merged;
        }
      }
      
      // Get patterns for all combinations of widths and depths
      widthsToCheck.forEach((w) => {
        depthsToCheck.forEach((d) => {
          const key = `${w}|${d}`;
          const list = GRATE_CONFIG.fields.pattern.byWidthDepth[key] || [];
          list.forEach((pid) => {
            // Store first occurrence or update if same pattern appears in multiple combos
            if (!patternMap[pid]) {
              patternMap[pid] = {
                meta: getPatternMeta(pid),
                concreteWidth: w,
                concreteDepth: d
              };
            }
          });
        });
      });
      
      // Convert to array of pattern objects with concrete dimensions
      return Object.keys(patternMap).map((pid) => {
        const item = patternMap[pid];
        return {
          ...item.meta,
          concreteWidth: item.concreteWidth,
          concreteDepth: item.concreteDepth
        };
      });
    }
    case "length": {
      if (!width || !depth || !pattern) return [];
      const key = keyWidthDepthPattern(width, depth, pattern);
      const list = GRATE_CONFIG.fields.length.byCombo[key] || [];
      return list.map((lid) => GRATE_CONFIG.fields.length.meta[lid]);
    }
    case "accessories": {
      if (!width || !pattern) return [];
      const directKey = `${width}|${pattern}`;
      const wildcardKey = `${width}|*`;
      const list =
        GRATE_CONFIG.fields.accessories.byWidthPattern[directKey] ??
        GRATE_CONFIG.fields.accessories.byWidthPattern[wildcardKey] ??
        [];
      return list.map((aid) => getAccessoryMeta(aid));
    }
    case "summary":
    default:
      return [];
  }
}

// --- Derived selections when something upstream changes ---

function applyDerivedSelectionsFromStepIndex(changedIndex) {
  const steps = GRATE_CONFIG.steps;
  // console.log("Applying derived selections from step index:", changedIndex);
  // console.log('steps:', steps);

  // When width or depth changes, clear pattern and CLEAR all added lengths and accessories
  if (changedIndex < 1) {
    state.selections.pattern = null;
    // Clear all added items when width/depth changes
    state.addedLengths = [];
    state.addedAccessories = [];
  }

  // When pattern changes, re-evaluate added lengths and accessories (check availability)
  if (changedIndex === 1) {
    revalidateAddedLengths();
    state.addedAccessories = [];
    // revalidateAddedAccessories();
  }

  for (let i = changedIndex + 1; i < steps.length; i++) {
    const step = steps[i];
    if (!step.field) continue; // summary step
    // console.log('step',step)
    const field = step.field;
    const options = getAvailableOptionsForStep(step, state.selections);
    const existing = state.selections[field];
    // console.log('step.id',step.id)
    // console.log('options',options)
    if (step.id === "depth") {
      const width = state.selections.width;
      if (!width) {
        state.selections.depth = null;
      } else {
        const rule = GRATE_CONFIG.fields.depth.byWidth[width];
        if (!rule) {
          state.selections.depth = null;
        } else if (rule.options.length === 1) {
          const depthId = rule.options[0];
          const depthOpt = GRATE_CONFIG.fields.depth.optionsAll.find((d) => d.id === depthId);
          // Don't auto-select merged depths - let user choose from dropdown
          if (depthOpt && depthOpt.merged) {
            state.selections.depth = null;
          } else {
            state.selections.depth = depthId;
          }
        } else {
          // multiple depths; keep existing only if valid
          const valid = options.some((o) => o.id === existing);
          state.selections.depth = valid ? existing : null;
        }
      }
    } else if (step.type === "singleChoice") {
      const valid = options.some((o) => o.id === existing);
      if (!valid) {
        state.selections[field] = null;
      }
    } else if (step.type === "multiChoice") {
      const ids = new Set(options.map((o) => o.id));
      const prev = Array.isArray(existing) ? existing : [];
      const filtered = prev.filter((id) => ids.has(id));

      if (step.id === "accessories") {
        state.selections[field] = filtered;
      }
    }
  }
}

function revalidateAddedLengths() {
  let { width, depth, pattern } = state.selections;
  
  if (!width || !depth || !pattern) {
    // Clear all added lengths if required selections are gone
    state.addedLengths = [];
    return;
  }
  let patternMap = {}
  let widthsToCheck = [width]
  let depthsToCheck = [depth]
  let formatedGroupedDepth = state.groupedDepth ? `${state.groupedDepth.split('/')[0]}MM` : null
  let formatedGroupedWidth = state.groupedWidth ? `${state.groupedWidth.split('/')[0]}MM` : null
  // If depth is still grouped/merged, use first concrete for lookups
  if (formatedGroupedDepth && (formatedGroupedDepth === depth)) {
    const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
      (d) => d.id === state.groupedDepth
    );
    if (groupedDepthOpt && groupedDepthOpt.merged && groupedDepthOpt.merged.length > 0) {
      depthsToCheck = groupedDepthOpt.merged;
    }
  }
  if (formatedGroupedWidth && (formatedGroupedWidth === width)) {
    const groupedWidthOpt = GRATE_CONFIG.fields.width.options.find(
      (d) => d.id === state.groupedWidth
    );
    if (groupedWidthOpt && groupedWidthOpt.merged && groupedWidthOpt.merged.length > 0) {
      widthsToCheck = groupedWidthOpt.merged;
    }
  }
  widthsToCheck.forEach((w) => {
    depthsToCheck.forEach((d) => {
      const key = `${w}|${d}`;
      const list = GRATE_CONFIG.fields.pattern.byWidthDepth[key] || [];
      list.forEach((pid) => {
        // Store first occurrence or update if same pattern appears in multiple combos
        if (!patternMap[pid]) {
          patternMap[pid] = {
            meta: getPatternMeta(pid),
            concreteWidth: w,
            concreteDepth: d
          };
        }
      });
    });
  });
  console.log('pattern',pattern)
  console.log('patternMap',patternMap)

  // Get available lengths for current combination
  const key = keyWidthDepthPattern(patternMap[pattern].concreteWidth, patternMap[pattern].concreteDepth, pattern);
  console.log('key',key)
  const availableLengthIds = GRATE_CONFIG.fields.length.byCombo[key] || [];
  const availableSet = new Set(availableLengthIds);
  const perMeterPrice = getPerMeterPriceForPattern(width, depth, pattern);

  // Remove any added lengths that are no longer available, update prices for those that are
  console.log('availableSet',availableSet)
  state.addedLengths = state.addedLengths.filter(item => {
    if (!availableSet.has(item.lengthId)) {
      return false; // Remove this item - not available in new selection
    }
    // Update price if pattern changed (width/depth/pattern combo affects price)
    const newUnitPrice = calculateLengthVariantPrice(item.lengthId, perMeterPrice);
    if (newUnitPrice) {
      item.unitPrice = newUnitPrice;
      item.perMeterPrice = perMeterPrice;
    }
    return true;
  });
}

// function revalidateAddedAccessories() {
  //   const { width, depth, pattern } = state.selections;
    
  //   if (!width || !depth || !pattern) {
  //     // Clear all added accessories if required selections are gone
  //     state.addedAccessories = [];
  //     return;
  //   }
  //   const tag = getPatternTag(pattern);
  //   if (!tag) return { tagBasedAccessories: [], universalAccessories: [] };
  //   let widthsToCheck = [width];
  //   let depthsToCheck = [depth];
  //   let formatedGroupedDepth = state.groupedDepth ? `${state.groupedDepth.split('/')[0]}MM` : null
  //   let formatedGroupedWidth = state.groupedWidth ? `${state.groupedWidth.split('/')[0]}MM` : null
  //   // If depth is still grouped/merged, use first concrete for lookups
  //   if (formatedGroupedDepth && (formatedGroupedDepth === depth)) {
  //     const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
  //       (d) => d.id === state.groupedDepth
  //     );
  //     if (groupedDepthOpt && groupedDepthOpt.merged && groupedDepthOpt.merged.length > 0) {
  //       depthsToCheck = groupedDepthOpt.merged;
  //     }
  //   }
  //   if (formatedGroupedWidth && (formatedGroupedWidth === width)) {
  //     const groupedWidthOpt = GRATE_CONFIG.fields.width.options.find(
  //       (d) => d.id === state.groupedWidth
  //     );
  //     if (groupedWidthOpt && groupedWidthOpt.merged && groupedWidthOpt.merged.length > 0) {
  //       widthsToCheck = groupedWidthOpt.merged;
  //     }
  //   }

  //   // Get tag-based accessories for ALL width/depth combinations
  //   let accessoriesSet = new Set();
  //   widthsToCheck.forEach((w) => {
  //     depthsToCheck.forEach((d) => {
  //       const widthDepthKey = `${w}|${d}`;
  //       if (ACCESSORY_CONFIG.byTag[tag] && ACCESSORY_CONFIG.byTag[tag][pattern]) {
  //         const accs = ACCESSORY_CONFIG.byTag[tag][pattern][widthDepthKey] || [];
  //         accs.forEach(acc => {
  //           // Use JSON stringified version to avoid duplicate objects
  //           accessoriesSet.add(JSON.stringify(acc));
  //         });
  //       }
  //     });
  //   });

  //   // Convert back from JSON strings to objects
  //   const tagBasedAccessories = Array.from(accessoriesSet).map(acc => JSON.parse(acc));

  //   // Get universal accessories for the tag and width|depth combination
  //   let universalAccessoriesSet = new Set();
  //   widthsToCheck.forEach((w) => {
  //     depthsToCheck.forEach((d) => {
  //       const widthDepthKey = `${w}|${d}`;
        
  //       // Check if universal accessories exist for this tag
  //       if (ACCESSORY_CONFIG.universal[tag]) {
  //         const accs = ACCESSORY_CONFIG.universal[tag][widthDepthKey] || [];
  //         accs.forEach(acc => {
  //           universalAccessoriesSet.add(JSON.stringify(acc));
  //         });
  //       }
  //     });
  //   });
    
  //   // Convert back from JSON strings to objects
  //   const universalAccessories = Array.from(universalAccessoriesSet).map(acc => JSON.parse(acc));
  //   console.log('tagBasedAccessories',tagBasedAccessories)
  //   console.log('universalAccessories',universalAccessories)
  //   // Get available accessories for current combination
  //   const directKey = `${width}|${pattern}`;
  //   const wildcardKey = `${width}|*`;
  //   const availableAccessoryIds = GRATE_CONFIG.fields.accessories.byWidthPattern[directKey] ??
  //                                   GRATE_CONFIG.fields.accessories.byWidthPattern[wildcardKey] ?? [];
  //   const availableSet = new Set(availableAccessoryIds);

  //   // Remove any added accessories that are no longer available
  //   state.addedAccessories = state.addedAccessories.filter(item => {
  //     return availableSet.has(item.accessoryId);
  //   });
// }

// --- Price calculation ---

function calculateTotalPrice() {
  // Calculate total price for all added lengths and accessories
  let total = 0;
  state.addedLengths.forEach(item => {
    if (item.unitPrice) {
      total += item.unitPrice * item.quantity;
    }
  });
  state.addedAccessories.forEach(item => {
    total += item.price * item.quantity;
  });
  return total > 0 ? total : null;
}

function calculatePriceBreakdown() {
  let gratesTotal = 0;
  let accessoriesTotal = 0;
  
  state.addedLengths.forEach(item => {
    if (item.unitPrice) {
      gratesTotal += item.unitPrice * item.quantity;
    }
  });
  
  state.addedAccessories.forEach(item => {
    accessoriesTotal += item.price * item.quantity;
  });
  
  return {
    gratesTotal: gratesTotal,
    accessoriesTotal: accessoriesTotal,
    total: gratesTotal + accessoriesTotal
  };
}

// --- Validation per step ---

function isStepValid(step) {
  const selections = state.selections;
  const options = getAvailableOptionsForStep(step, selections);

  if (step.id === "summary") {
    const price = calculatePrice(selections);
    return price != null;
  }

  if (!step.field) return true;

  const value = selections[step.field];

  if (step.type === "singleChoice") {
    return (
      !!value && options.some((opt) => opt.id === value)
    );
  }

  if (step.type === "multiChoice") {
    const selected = Array.isArray(value) ? value : [];
    const availableIds = options.map((o) => o.id);

    if (step.allowEmpty) {
      // accessories may be empty even if options exist
      return true;
    }

    return selected.length > 0;
  }

  return false;
}

// --- Auto-scroll helper ---

function autoScrollToStep(stepOrder, offset = 0) {
  // setTimeout(() => {
  //   const stepSection = document.querySelector(`[data-step="${stepOrder}"]`);
  //   if (stepSection) {
  //     stepSection.scrollIntoView({ behavior: "smooth", block: "start" });
  //   }
  // }, 100);
  setTimeout(() => {
    const stepSection = document.querySelector(
      `[data-step="${stepOrder}"]`
    );

    if (!stepSection) return;

    const elementTop =
      stepSection.getBoundingClientRect().top + window.pageYOffset;

    window.scrollTo({
      top: elementTop - offset,
      behavior: "smooth"
    });
  }, 100);
}

// --- Rendering (Long-form all-steps view) ---

function renderAllSteps() {
  GRATE_CONFIG.steps.forEach((step, index) => {
    const stepSection = document.querySelector(`[data-step="${step.order}"]`);
    if (!stepSection) return;

    const errorArea = stepSection.querySelector(`#step-${step.order}-error`);
    if (errorArea) errorArea.textContent = "";

    // Handle combined width+depth step
    if (step.id === "width") {
      renderCombinedWidthDepthStep(step, stepSection);
      return;
    }

    // Clear content area
    const contentArea = stepSection.querySelector(`#step-${step.order}-content`);
    if (!contentArea) return;
    contentArea.innerHTML = "";

    // Determine if step is enabled (dependencies met)
    const isEnabled = isStepEnabled(step);

    if (!isEnabled) {
      const disabledMsg = document.createElement("p");
      disabledMsg.className = "field-hint field-hint--disabled";
      disabledMsg.textContent = getDependencyMessage(step);
      contentArea.appendChild(disabledMsg);
      stepSection.classList.add("config-step--disabled");
      return;
    }

    stepSection.classList.remove("config-step--disabled");

    if (step.type === "summary") {
      renderSummaryStep(step, contentArea);
    } else if (step.id === "pattern") {
      renderPatternWithPriceStep(step, contentArea);
    } else if (step.id === "length") {
      renderLengthVariantsStep(step, contentArea);
    } else if (step.id === "accessories") {
      // console.log('accessories Step');
      
      renderAccessoriesStep(step, contentArea);
    } else {
      renderFieldStep(step, contentArea);
    }
  });
}

function renderCombinedWidthDepthStep(step, stepSection) {
  const contentDiv = stepSection.querySelector("#step-1-content");
  if (!contentDiv) return;

  contentDiv.innerHTML = "";
  
  // Create container with 2 columns: labels left, tiles right
  const container = document.createElement("div");
  container.className = "width-depth-container";

  // Left side: Labels
  // const labelsCol = document.createElement("div");
  // labelsCol.className = "width-depth-labels-column";

  // const widthLabel = document.createElement("div");
  // widthLabel.className = "width-depth-label";
  // widthLabel.textContent = "Width";

  // const depthLabel = document.createElement("div");
  // depthLabel.className = "width-depth-label";
  // depthLabel.textContent = "Depth";

  // labelsCol.appendChild(widthLabel);
  // labelsCol.appendChild(depthLabel);

  // Right side: Tiles grid
  const tilesCol = document.createElement("div");
  tilesCol.className = "width-depth-tiles-column";

  renderWidthDepthTiles(tilesCol);

  // container.appendChild(labelsCol);
  container.appendChild(tilesCol);
  contentDiv.appendChild(container);

  stepSection.classList.remove("config-step--disabled");
}

function renderWidthDepthTiles(tilesContainer) {
  const selectedWidth = state.selections.width;
  const selectedDepth = state.selections.depth;

  // Create tiles with grouped values (4 tiles as specified)
  const tiles = [
    { width: "125MM", depth: "80MM" },
    { width: "140/150MM", depth: "125MM" },
    { width: "200MM", depth: "170MM" },
    { width: "300MM", depth: "170/200MM" }
  ];

  const tilesGrid = document.createElement("div");
  tilesGrid.className = "width-depth-tiles-grid";

  tiles.forEach((tile) => {
    const tileEl = document.createElement("div");
    tileEl.className = "width-depth-tile";

    // Check if selected
    // Extract concrete values from grouped values for comparison
    // const widthValues = tile.width.includes("/")
    //   ? tile.width.split("/").map((v) => v.trim())
    //   : [tile.width];
    const widthValues = tile.width.includes("/")
      ? tile.width.split("/").map((v) => `${v.trim()}MM`)
      : [tile.width];
    const depthValues = tile.depth.includes("/")
      ? tile.depth.split("/").map((v) => `${v.trim()}MM`)
      : [tile.depth];

    const isSelected = widthValues.includes(selectedWidth) && depthValues.includes(selectedDepth);
    if (isSelected) {
      // console.log('isSelected')
      tileEl.classList.add("selected");
    }

    // Tile content: Width × Depth
    const content = document.createElement("div");
    content.className = "tile-content";
    content.innerHTML = `<span class="width-con"> ${tile.width} (W)</span><span class="x-con"> X </span><span class="depth-con">${tile.depth} (D)</span>`;

    tileEl.appendChild(content);

    // Click handler
    tileEl.addEventListener("click", () => {
      // If grouped, select first value; if single, select that value
      // const concreteWidth = tile.width.includes("/")
      //   ? tile.width.split("/")[0].trim()
      //   : tile.width;
      // const concreteDepth = tile.depth.includes("/")
      //   ? tile.depth.split("/")[0].trim()
      //   : tile.depth;
      const concreteWidth = tile.width
      const concreteDepth = tile.depth
      // console.log('concreteWidth',concreteWidth)
      // console.log('concreteDepth',concreteDepth)
      selectConcreteWidthAndDepth(concreteWidth, concreteDepth);
    });

    tilesGrid.appendChild(tileEl);
  });

  tilesContainer.appendChild(tilesGrid);
}

function isDepthEnabledForWidth(depthId, widthValue) {
  if (!widthValue) return false;

  // First check if width is directly in the byWidth rules (concrete width)
  const directRule = GRATE_CONFIG.fields.depth.byWidth[widthValue];
  if (directRule && directRule.options.includes(depthId)) {
    return true;
  }

  // Otherwise, check if width is in options (including merged options)
  const widthOpt = GRATE_CONFIG.fields.width.options.find(
    (o) => o.id === widthValue
  );

  if (!widthOpt) return false;

  // Get actual widths for merged option
  const actualWidths = widthOpt.merged ? widthOpt.merged : [widthValue];

  // Check if depth is available for any of the actual widths
  for (const w of actualWidths) {
    const rule = GRATE_CONFIG.fields.depth.byWidth[w];
    if (rule && rule.options.includes(depthId)) {
      return true;
    }
  }

  return false;
}

function handleWidthSelection(widthValue) {
  const widthOpt = GRATE_CONFIG.fields.width.options.find(
    (o) => o.id === widthValue
  );

  // For grouped width (merged), select the first concrete width but track the grouped ID
  if (widthOpt && widthOpt.merged) {
    state.groupedWidth = widthValue; // Store the grouped width ID
    selectConcreteWidthAndDepth(widthOpt.merged[0]);
  } else {
    // For single width, select it as-is
    state.groupedWidth = null;
    selectConcreteWidthAndDepth(widthValue);
  }
}

function showMergedWidthDropdown(mergedWidthId) {
  const widthOpt = GRATE_CONFIG.fields.width.options.find(
    (o) => o.id === mergedWidthId
  );

  if (!widthOpt || !widthOpt.merged) return;

  // Now show dropdown for the merged option
  const widthPill = document.querySelector(
    `input[name="width"][value="${mergedWidthId}"]`
  )?.parentElement;

  if (widthPill) {
    // Check if dropdown already exists - if so, don't create duplicate
    if (widthPill.querySelector(".merged-dropdown-inline")) {
      return;
    }

    // Create inline dropdown
    const dropdown = document.createElement("div");
    dropdown.className = "merged-dropdown-inline open";

    widthOpt.merged.forEach((concreteWidth) => {
      const item = document.createElement("div");
      item.className = "merged-dropdown-inline-item";
      if (concreteWidth === state.selections.width) {
        item.classList.add("selected");
      }
      item.textContent = concreteWidth;

      item.addEventListener("click", (e) => {
        e.stopPropagation();
        e.preventDefault();
        const dropdownToRemove = dropdown;
        if (dropdownToRemove.parentElement) {
          dropdownToRemove.remove();
        }
        selectConcreteWidthAndDepth(concreteWidth);
      });

      dropdown.appendChild(item);
    });

    widthPill.appendChild(dropdown);

    // Prevent propagation on dropdown itself
    dropdown.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    // Stop propagation on the pill to prevent outer click listener
    widthPill.addEventListener("click", (e) => {
      if (e.target.closest(".merged-dropdown-inline")) {
        e.stopPropagation();
      }
    });

    // Close dropdown when clicking outside
    const closeDropdown = (e) => {
      // Check if click is outside the widthPill
      if (!widthPill.contains(e.target)) {
        if (dropdown && dropdown.parentElement) {
          dropdown.remove();
        }
        document.removeEventListener("click", closeDropdown);
      }
    };

    // Use setTimeout to avoid the current click event
    setTimeout(() => {
      document.addEventListener("click", closeDropdown);
    }, 0);
  }
}

function selectConcreteWidthAndDepth(concreteWidth, concreteDepth) {
  concreteWidth.includes('/') ? state.selections.width = `${concreteWidth.split('/')[0].trim()}MM` : state.selections.width = concreteWidth;
  concreteWidth.includes('/') ? state.groupedWidth = concreteWidth : state.groupedWidth = null;
  
  // If depth is provided (from tile click), use it directly
  if (concreteDepth) {
    concreteDepth.includes('/') ? state.selections.depth = `${concreteDepth.split('/')[0].trim()}MM` : state.selections.depth = concreteDepth;
    // state.groupedWidth = null;
    concreteDepth.includes('/') ? state.groupedDepth = concreteDepth : state.groupedDepth = null;
  } else {
    // console.log('concreteWidth selected in else:');
    // Otherwise, auto-select depth if only one available
    const rule = GRATE_CONFIG.fields.depth.byWidth[concreteWidth];
    if (rule && rule.options.length === 1) {
      const depthId = rule.options[0];
      state.selections.depth = depthId;
      
      const depthOpt = GRATE_CONFIG.fields.depth.optionsAll.find((d) => d.id === depthId);
      if (depthOpt && depthOpt.merged) {
        state.groupedDepth = depthId;
      } else {
        state.groupedDepth = null;
      }
    }
  }

  const stepIndex = GRATE_CONFIG.steps.findIndex((s) => s.id === "width");
  applyDerivedSelectionsFromStepIndex(stepIndex);

  renderAllSteps();
  renderSidebar();
  
  // Only auto-scroll to Step 2 if width and depth are selected
  if (state.selections.width && state.selections.depth) {
    autoScrollToStep(2,200);
  }
}

function handleMergedDepthSelection(mergedDepthId, wrapper) {
  const depthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
    (d) => d.id === mergedDepthId
  );

  if (!depthOpt || !depthOpt.merged) return;

  // Show inline dropdown for merged depth
  showMergedDepthDropdown(mergedDepthId, wrapper);
}

function showMergedDepthDropdown(mergedDepthId, wrapper) {
  const depthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
    (d) => d.id === mergedDepthId
  );

  if (!depthOpt || !depthOpt.merged) return;

  // Check if dropdown already exists - if so, don't create duplicate
  if (wrapper.querySelector(".merged-dropdown-inline")) {
    return;
  }

  // Create inline dropdown
  const dropdown = document.createElement("div");
  dropdown.className = "merged-dropdown-inline open";

  depthOpt.merged.forEach((concreteDepth) => {
    const item = document.createElement("div");
    item.className = "merged-dropdown-inline-item";
    if (concreteDepth === state.selections.depth) {
      item.classList.add("selected");
    }
    item.textContent = concreteDepth;

    item.addEventListener("click", (e) => {
      e.stopPropagation();
      dropdown.remove();
      handleDepthSelection(concreteDepth);
    });

    dropdown.appendChild(item);
  });

  wrapper.appendChild(dropdown);

  // Close dropdown when clicking outside (with proper cleanup)
  const closeDropdown = (e) => {
    if (!wrapper.contains(e.target)) {
      if (dropdown.parentElement) {
        dropdown.remove();
      }
      document.removeEventListener("click", closeDropdown);
    }
  };

  document.addEventListener("click", closeDropdown);
}

function handleDepthSelection(depthId) {
  const selectedWidth = state.selections.width;
  const widthOpt = GRATE_CONFIG.fields.width.options.find(
    (o) => o.id === selectedWidth
  );

  if (widthOpt && widthOpt.merged) {
    // For merged width, find which concrete width this depth belongs to
    const actualWidths = widthOpt.merged;
    for (const w of actualWidths) {
      const rule = GRATE_CONFIG.fields.depth.byWidth[w];
      if (rule && rule.options.includes(depthId)) {
        state.selections.width = w;
        break;
      }
    }
  }

  state.selections.depth = depthId;
  
  // Track if this depth is grouped/merged
  const depthOpt = GRATE_CONFIG.fields.depth.optionsAll.find((d) => d.id === depthId);
  if (depthOpt && depthOpt.merged) {
    state.groupedDepth = depthId; // Store the grouped depth ID
  } else {
    state.groupedDepth = null;
  }

  const stepIndex = GRATE_CONFIG.steps.findIndex((s) => s.id === "width");
  applyDerivedSelectionsFromStepIndex(stepIndex);

  renderAllSteps();
  renderSidebar();
  
  // Auto-scroll to Step 2 (pattern) when width/depth selection is complete
  autoScrollToStep(2,200);
}

function isStepEnabled(step) {
  const { width, depth, pattern } = state.selections;

  switch (step.id) {
    case "width":
      return true;
    case "pattern":
      return !!width && !!depth;
    case "length":
      return !!width && !!depth && !!pattern;
    case "accessories":
      if (!width || !depth || !pattern) return false;
      // Disable accessories step if no accessories are available for this combination
      const availableAccessories = getAvailableOptionsForStep(step, state.selections);
      return availableAccessories.length > 0;
    case "summary":
      return state.addedLengths.length > 0;
    default:
      return true;
  }
}

function getDependencyMessage(step) {
  switch (step.id) {
    case "pattern":
      return "Select width and depth first";
    case "length":
      return "Select a pattern first";
    case "accessories":
      return "Select pattern and length first";
    default:
      return "Prerequisites not met";
  }
}

function renderPatternWithPriceStep(step, contentArea) {
  const selections = state.selections;
  let options = getAvailableOptionsForStep(step, selections);

  // console.log('Rendering pattern step with options:', options);

  // Sort options according to PATTERN_SORT_ORDER
  options = options.sort((a, b) => {
    const indexA = PATTERN_SORT_ORDER.indexOf(a.id);
    const indexB = PATTERN_SORT_ORDER.indexOf(b.id);
    
    // If both are in the sort order, compare their indices
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    }
    
    // If only one is in the sort order, it comes first
    if (indexA !== -1) return -1;
    if (indexB !== -1) return 1;
    
    // If neither is in the sort order, maintain original order
    return 0;
  });

  // console.step("options",options);
  // console.log("options",options);
  

  const list = document.createElement("div");
  list.className = "option-list";

  if (options.length === 0) {
    const hint = document.createElement("p");
    hint.className = "field-hint";
    hint.textContent = "No patterns available for the current selection.";
    contentArea.appendChild(hint);
    return;
  }

  options.forEach((option) => {
    const itemDiv = document.createElement("div");
    itemDiv.className = "option-item";

    const input = document.createElement("input");
    input.type = "radio";
    input.id = `pattern-${option.id}`;
    input.name = "pattern";
    input.value = option.id;
    input.checked = selections.pattern === option.id;

    const label = document.createElement("label");
    label.htmlFor = `pattern-${option.id}`;
    label.className = "option-label";

    // Thumbnail if available
    if (step.showThumbnails && option.thumbnail) {
      const img = document.createElement("img");
      img.src = option.thumbnail;
      img.className = "option-thumbnail";
      img.alt = option.label;
      label.appendChild(img);
    }

    // Get concrete dimensions for this pattern (may differ from selected if grouped)
    const concreteWidth = option.concreteWidth || selections.width;
    const concreteDepth = option.concreteDepth || selections.depth;

    const labelMainContainer = document.createElement("div");
    labelMainContainer.className = "option-label-wrapper";

    // Pattern name and width on same line
    const labelContainer = document.createElement("div");
    // labelContainer.className = "option-label-top";
    labelContainer.className = "option-label-details";
    
    const labelText = document.createElement("span");
    labelText.className = "option-label-text";
    labelText.textContent = option.label;
    labelContainer.appendChild(labelText);

    // const widthEl = document.createElement("span");
    // widthEl.className = "option-width";
    // widthEl.textContent = `Width: ${concreteWidth}`;
    // labelContainer.appendChild(widthEl);

    const perMeterPrice = getPerMeterPriceForPattern(
      concreteWidth,
      concreteDepth,
      option.id
    );
    if (perMeterPrice) {
      const priceEl = document.createElement("span");
      priceEl.className = "option-price";
      priceEl.textContent = `${formatCurrency(perMeterPrice)}/m`;
      labelContainer.appendChild(priceEl);
    }

    labelMainContainer.appendChild(labelContainer);

    const avLengths = getAvailableLenghts(option.id)
    if(avLengths.length > 0){
      const lengthsContainer = document.createElement("div");
      lengthsContainer.className = "option-label-lengths";
      // console.log('avLengths.length',avLengths.length)
      avLengths.forEach((element,index) => {
        if(avLengths.length == 3){
          // console.log('index',index)
          if(index == 0){
            const lengthText = document.createElement("span");
            lengthText.className = "length-text";
            lengthText.style.width = '30%';
            lengthText.textContent = element;
            lengthsContainer.appendChild(lengthText);
          }
          if(index == 1){
            const lengthText = document.createElement("span");
            lengthText.className = "length-text";
            lengthText.style.width = '60%';
            lengthText.textContent = element;
            lengthsContainer.appendChild(lengthText);
          }
          if(index == 2){
            const lengthText = document.createElement("span");
            lengthText.className = "length-text";
            lengthText.style.width = '100%';
            lengthText.textContent = element;
            lengthsContainer.appendChild(lengthText);
          }
        }
        if(avLengths.length == 2){
          if(index == 0){
            const lengthText = document.createElement("span");
            lengthText.className = "length-text";
            lengthText.style.width = '60%';
            lengthText.textContent = element;
            lengthsContainer.appendChild(lengthText);
          }
          if(index == 1){
            const lengthText = document.createElement("span");
            lengthText.className = "length-text";
            lengthText.style.width = '100%';
            lengthText.textContent = element;
            lengthsContainer.appendChild(lengthText);
          }
        }
        if(avLengths.length == 1){
          if(index == 0){
            const lengthText = document.createElement("span");
            lengthText.className = "length-text";
            lengthText.style.width = '100%';
            lengthText.textContent = element;
            lengthsContainer.appendChild(lengthText);
          }
        }
      });
      labelMainContainer.appendChild(lengthsContainer);
    }
    // label.appendChild(labelContainer);

    // Price and depth on second line
    const priceContainer = document.createElement("div");
    priceContainer.className = "option-label-dimensions";

    const widthEl = document.createElement("span");
    widthEl.className = "option-width";
    widthEl.textContent = `Width: ${concreteWidth}`;
    priceContainer.appendChild(widthEl);

    // Add per-meter price using concrete dimensions
    // const perMeterPrice = getPerMeterPriceForPattern(
    //   concreteWidth,
    //   concreteDepth,
    //   option.id
    // );
    // if (perMeterPrice) {
    //   const priceEl = document.createElement("span");
    //   priceEl.className = "option-price";
    //   priceEl.textContent = `${formatCurrency(perMeterPrice)}/m`;
    //   priceContainer.appendChild(priceEl);
    // }

    const depthEl = document.createElement("span");
    depthEl.className = "option-depth";
    depthEl.textContent = `Depth: ${concreteDepth}`;
    priceContainer.appendChild(depthEl);

    labelMainContainer.appendChild(priceContainer);
    label.appendChild(labelMainContainer);

    itemDiv.appendChild(input);
    itemDiv.appendChild(label);

    input.addEventListener("change", () => {
      // console.log('pattren clicked');
      
      state.selections.pattern = option.id;
      
      // If there's a grouped depth, convert it to first concrete depth for data lookups
      if (state.groupedDepth) {
        const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
          (d) => d.id === state.groupedDepth
        );
        if (groupedDepthOpt && groupedDepthOpt.merged && groupedDepthOpt.merged.length > 0) {
          // Switch to first concrete depth for downstream logic (length lookups, etc.)
          state.selections.depth = groupedDepthOpt.merged[0];
        }
      }
      
      applyDerivedSelectionsFromStepIndex(GRATE_CONFIG.steps.findIndex(s => s.id === "pattern"));
      renderAllSteps();
      renderSidebar();
      
      // Auto-scroll to Step 3 (length variants) when pattern selection is complete
      autoScrollToStep(3,200);
    });

    list.appendChild(itemDiv);
  });

  contentArea.appendChild(list);
}
function getAvailableLenghts(pattern){
  if(!pattern){
    // console.log('no pattren found')
    return;
  }
  const selections = state.selections;
  let { width, depth } = selections;
  let groupedWidthArray = [];
  let groupedDepthArray = [];

  
  
  if (!width || !depth || !pattern) return;

  // If depth is still grouped/merged, use first concrete for lookups
  if (state.groupedDepth === depth) {
    const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
      (d) => d.id === state.groupedDepth
    );
    if (groupedDepthOpt && groupedDepthOpt.merged && groupedDepthOpt.merged.length > 0) {
      depth = groupedDepthOpt.merged[0];
    }
  }
  let key = keyWidthDepthPattern(width, depth, pattern);
  // const availableLengthIds = GRATE_CONFIG.fields.length.byCombo[key] || [];
  let availableLengthIds = [];
  if(state.groupedWidth){
    let actualWidths = state.groupedWidth.split('/').map( w => w.trim().includes('MM') ? w.trim() : w.trim()+'MM');
    groupedWidthArray = actualWidths;
    // console.log('actualWidths');
    // console.log(actualWidths);
    actualWidths.forEach( w => {
      let tempKey = keyWidthDepthPattern(w, depth, pattern);
      let tempLengthIds = GRATE_CONFIG.fields.length.byCombo[tempKey] || []; 
      availableLengthIds.push(...tempLengthIds);
    });
    // Remove duplicates
    availableLengthIds = Array.from(new Set(availableLengthIds));
    
  }else if(state.groupedDepth){
    let actualDepths = state.groupedDepth.split('/').map( d => d.trim().includes('MM') ? d.trim() : d.trim()+'MM');
    groupedDepthArray = actualDepths;
    // console.log('actualDepths:');
    // console.log(actualDepths);
    actualDepths.forEach( d => {
      let tempKey = keyWidthDepthPattern(width, d, pattern);
      let tempLengthIds = GRATE_CONFIG.fields.length.byCombo[tempKey] || []; 
      availableLengthIds.push(...tempLengthIds);
    });
    // Remove duplicates
    availableLengthIds = Array.from(new Set(availableLengthIds));
  }else{
    availableLengthIds = GRATE_CONFIG.fields.length.byCombo[key] || [];
  }
  // console.log('availableLengthIds:');
  // console.log(availableLengthIds);
  return availableLengthIds
}
function renderLengthVariantsStep(step, contentArea) {
  const selections = state.selections;
  let { width, depth, pattern } = selections;
  let groupedWidthArray = [];
  let groupedDepthArray = [];

  
  
  if (!width || !depth || !pattern) return;

  // If depth is still grouped/merged, use first concrete for lookups
  if (state.groupedDepth === depth) {
    const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
      (d) => d.id === state.groupedDepth
    );
    if (groupedDepthOpt && groupedDepthOpt.merged && groupedDepthOpt.merged.length > 0) {
      depth = groupedDepthOpt.merged[0];
    }
  }
  let key = keyWidthDepthPattern(width, depth, pattern);
  // const availableLengthIds = GRATE_CONFIG.fields.length.byCombo[key] || [];
  let availableLengthIds = [];
  if(state.groupedWidth){
    let actualWidths = state.groupedWidth.split('/').map( w => w.trim().includes('MM') ? w.trim() : w.trim()+'MM');
    groupedWidthArray = actualWidths;
    // console.log('actualWidths');
    // console.log(actualWidths);
    actualWidths.forEach( w => {
      let tempKey = keyWidthDepthPattern(w, depth, pattern);
      let tempLengthIds = GRATE_CONFIG.fields.length.byCombo[tempKey] || []; 
      availableLengthIds.push(...tempLengthIds);
    });
    // Remove duplicates
    availableLengthIds = Array.from(new Set(availableLengthIds));
    
  }else if(state.groupedDepth){
    let actualDepths = state.groupedDepth.split('/').map( d => d.trim().includes('MM') ? d.trim() : d.trim()+'MM');
    groupedDepthArray = actualDepths;
    // console.log('actualDepths:');
    // console.log(actualDepths);
    actualDepths.forEach( d => {
      let tempKey = keyWidthDepthPattern(width, d, pattern);
      let tempLengthIds = GRATE_CONFIG.fields.length.byCombo[tempKey] || []; 
      availableLengthIds.push(...tempLengthIds);
    });
    // Remove duplicates
    availableLengthIds = Array.from(new Set(availableLengthIds));
  }else{
    availableLengthIds = GRATE_CONFIG.fields.length.byCombo[key] || [];
  }
  // console.log('availableLengthIds:');
  // console.log(availableLengthIds);

  // Get available lengths for this combination
  
  
  if (availableLengthIds.length === 0) {
    const hint = document.createElement("p");
    hint.className = "field-hint";
    hint.textContent = "No lengths available for this combination.";
    contentArea.appendChild(hint);
    return;
  }

  const variantsGrid = document.createElement("div");
  variantsGrid.className = "length-variants-grid";

  // Build arrays for pricing lookup
  let widthsForPrice = state.groupedWidth ? groupedWidthArray : [width];
  let depthsForPrice = state.groupedDepth ? groupedDepthArray : [depth];
  
  const perMeterPrice = getPerMeterPriceForPattern(widthsForPrice, depthsForPrice, pattern);

  availableLengthIds.forEach((lengthId) => {
    const lengthMeta = GRATE_CONFIG.fields.length.meta[lengthId];
    const variantCard = document.createElement("div");
    variantCard.className = "length-variant-card";

    // Length label
    const lengthLabel = document.createElement("div");
    lengthLabel.className = "variant-length-label";
    lengthLabel.textContent = lengthMeta.label;
    variantCard.appendChild(lengthLabel);

    // Quantity selector - shows current cart quantity
    const qtyContainer = document.createElement("div");
    qtyContainer.className = "qty-selector";

    const minusBtn = document.createElement("button");
    minusBtn.className = "qty-btn qty-minus";
    minusBtn.textContent = "-";
    minusBtn.type = "button";

    const qtyDisplay = document.createElement("div");
    qtyDisplay.className = "qty-display";
    const currentQty = getAddedLengthQuantity(lengthId);
    qtyDisplay.textContent = currentQty || "0";

    const plusBtn = document.createElement("button");
    plusBtn.className = "qty-btn qty-plus";
    plusBtn.textContent = "+";
    plusBtn.type = "button";

    minusBtn.addEventListener("click", () => {
      const currentQty = getAddedLengthQuantity(lengthId);
      if (currentQty > 0) {
        removeLengthVariantFromCart(lengthId, 1);
        qtyDisplay.textContent = currentQty - 1;
        renderSidebar();
      }
    });

    plusBtn.addEventListener("click", () => {
      // console.log('perMeterPrice')
      // console.log(perMeterPrice)
      addLengthVariantToCart(lengthId, 1, perMeterPrice);
      const newQty = getAddedLengthQuantity(lengthId);
      qtyDisplay.textContent = newQty;
      renderSidebar();
    });

    qtyContainer.appendChild(minusBtn);
    qtyContainer.appendChild(qtyDisplay);
    qtyContainer.appendChild(plusBtn);
    variantCard.appendChild(qtyContainer);

    // Price per unit
    const unitPrice = calculateLengthVariantPrice(lengthId, perMeterPrice);
    const priceLabel = document.createElement("div");
    priceLabel.className = "variant-price";
    if (unitPrice) {
      priceLabel.textContent = formatCurrency(unitPrice);
    }
    variantCard.appendChild(priceLabel);

    variantsGrid.appendChild(variantCard);
  });

  contentArea.appendChild(variantsGrid);
}

function renderAccessoriesStep(step, contentArea) {
  const { pattern, width, depth } = state.selections;
  // console.log('renderAccessoriesStep');
  
  if (!pattern || !width || !depth) {
    // console.log('pattren width depth not defined');
    
    if (contentArea) {
      // console.log('content area not defined');
      
      contentArea.innerHTML = "<p class='field-hint'>Please complete previous steps first.</p>";
    }
    return;
  }
  // console.log('{ pattern, width, depth }');
  // console.log({ pattern, width, depth });
  // console.log('contentArea');
  // console.log(contentArea);
  
  
  
  // Get concrete depth if needed
  let concreteDepth = depth;
  if (state.groupedDepth === depth) {
    const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
      (d) => d.id === state.groupedDepth
    );
    if (groupedDepthOpt && groupedDepthOpt.merged && groupedDepthOpt.merged.length > 0) {
      concreteDepth = groupedDepthOpt.merged[0];
    }
  }

  // Get accessories for current selection
  const { tagBasedAccessories, universalAccessories } = getAccessoriesForSelection(pattern, width, concreteDepth);
  
  let html = '<div class="accessories-container">';
  
  // Tag-based accessories section
  if (tagBasedAccessories.length > 0) {
    html += '<div class="accessories-section"><div class="accessories-section-title">Recommended Accessories</div><div class="accessories-section-grid">';
    tagBasedAccessories.forEach(accessory => {
      const addedQty = getAddedAccessoryQuantity(accessory.accessory);
      html += `
        <div class="length-variant-card">
          <img src="${accessory.img_url}" alt="${accessory.name}" class="variant-image">
          <div class="variant-length-label">${accessory.name}</div>
          <div class="variant-price">${formatCurrency(accessory.price)}</div>
          <div class="qty-selector">
            <button class="qty-btn qty-minus" type="button" onclick="removeAccessoryFromCartSingle('${accessory.accessory}')">-</button>
            <div class="qty-display" id="qty-display-${accessory.accessory}">${addedQty || '0'}</div>
            <button class="qty-btn qty-plus" type="button" onclick="addAccessoryToCartSingle('${accessory.accessory}', ${accessory.variant_id}, '${accessory.name.replace(/'/g, "\\'")}', '${accessory.img_url}', ${accessory.price})">+</button>
          </div>
        </div>
      `;
    });
    html += '</div></div>';
  }
  
  // Universal accessories section - as accordion
  if (universalAccessories.length > 0) {
    html += '<div class="accessory-group">';
    if(additionalAccessoriesAccordionCollapsed){
      html += '<button class="accordion-header" type="button">Additional Items</button>';
      html += '<div class="accordion-content" style="display: block;"><div class="accessories-section-grid">';
    }else{
      html += '<button class="accordion-header collapsed" type="button">Additional Items</button>';
      html += '<div class="accordion-content" style="display: none;"><div class="accessories-section-grid">';
    }
    universalAccessories.forEach(accessory => {
      // Check if this is holesaw - render with variant dropdown
      if (accessory.accessory === 'holesaw') {
        html += renderHolesawAccessoryCard(accessory);
      } else {
        const addedQty = getAddedAccessoryQuantity(accessory.accessory);
        html += `
          <div class="length-variant-card">
            <img src="${accessory.img_url}" alt="${accessory.name}" class="variant-image">
            <div class="variant-length-label">${accessory.name}</div>
            <div class="variant-price">${formatCurrency(accessory.price)}</div>
            <div class="qty-selector">
              <button class="qty-btn qty-minus" type="button" onclick="removeAccessoryFromCartSingle('${accessory.accessory}')">-</button>
              <div class="qty-display" id="qty-display-${accessory.accessory}">${addedQty || '0'}</div>
              <button class="qty-btn qty-plus" type="button" onclick="addAccessoryToCartSingle('${accessory.accessory}', '${accessory.variant_id}', '${accessory.name.replace(/'/g, "\\'")}', '${accessory.img_url}', ${accessory.price})">+</button>
            </div>
          </div>
        `;
      }
    });
    html += '</div></div></div>';
  }
  
  if (tagBasedAccessories.length === 0 && universalAccessories.length === 0) {
    html += '<p class="field-hint">No accessories available for this combination.</p>';
  }
  
  html += '</div>';
  
  // Clear and render
  if (contentArea) {
    contentArea.innerHTML = html;
    
    // Add accordion toggle functionality
    const accordion = contentArea.querySelector('.accordion-header');
    const content = contentArea.querySelector('.accordion-content');
    if (accordion && content) {
      accordion.addEventListener('click', function() {
        this.classList.toggle('collapsed');
        additionalAccessoriesAccordionCollapsed = !additionalAccessoriesAccordionCollapsed
        if (content.style.display === 'none') {
          content.style.display = 'block';
        } else {
          content.style.display = 'none';
        }
      });
    }

    // Setup holesaw variant listeners
    setupHolesawVariantListeners();
  }
}

function renderHolesawAccessoryCard(accessory) {
  const variants = HOLESAW_VARIANTS.holesaw.variants;
  const currentVariantId = state.holesawVariantSelected;
  const currentVariantQty = getHolesawVariantQuantity(currentVariantId);
  const currentVariantInfo = getHolesawVariantInfo(currentVariantId);

  let html = `
    <div class="length-variant-card holesaw-card">
      <img src="${accessory.img_url}" alt="${accessory.name}" class="variant-image">
      <div class="variant-length-label">${accessory.name}</div>
      <!-- Price -->
      <div class="variant-price" id="holesaw-price-display">${formatCurrency(currentVariantInfo.price)}</div>
      <!-- Variant Dropdown -->
      <div class="holesaw-variant-selector">
        <label for="holesaw-variant-select" class="holesaw-variant-label">Select Variant:</label>
        <select id="holesaw-variant-select" class="holesaw-variant-dropdown">
  `;

  variants.forEach(variant => {
    const selected = variant.id === currentVariantId ? 'selected' : '';
    html += `<option value="${variant.id}" ${selected}>${variant.label}</option>`;
  });

  html += `
        </select>
      </div>

      <!-- Quantity Selector -->
      <div class="qty-selector">
        <button type="button" class="qty-btn qty-minus" data-holesaw-minus>-</button>
        <div class="qty-display" id="holesaw-qty-display">${currentVariantQty}</div>
        <button type="button" class="qty-btn qty-plus" data-holesaw-plus>+</button>
      </div>

      <!-- Hidden input to track current variant -->
      <input type="hidden" id="holesaw-variant-hidden" value="${currentVariantId}">
      <input type="hidden" id="holesaw-price-hidden" value="${currentVariantInfo.price}">
      <input type="hidden" id="holesaw-variant-id-hidden" value="${currentVariantInfo.variantId}">
      <input type="hidden" id="holesaw-img-url-hidden" value="${accessory.img_url}">
    </div>
  `;

  return html;
}

function renderLengthVariantsOnPatternStep(step, stepSection) {
  const selections = state.selections;
  let { width, depth, pattern } = selections;
  
  if (!width || !depth || !pattern) return;

  // If depth is still grouped/merged, use first concrete for lookups
  if (state.groupedDepth === depth) {
    const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
      (d) => d.id === state.groupedDepth
    );
    if (groupedDepthOpt && groupedDepthOpt.merged && groupedDepthOpt.merged.length > 0) {
      depth = groupedDepthOpt.merged[0];
    }
  }

  // Get available lengths for this combination
  const key = keyWidthDepthPattern(width, depth, pattern);
  const availableLengthIds = GRATE_CONFIG.fields.length.byCombo[key] || [];
  
  if (availableLengthIds.length === 0) {
    return;
  }

  // Create length variants container
  const variantsContainer = document.createElement("div");
  variantsContainer.className = "length-variants-container";

  const variantsLabel = document.createElement("h4");
  variantsLabel.textContent = "Select Length & Quantity";
  variantsContainer.appendChild(variantsLabel);

  const variantsGrid = document.createElement("div");
  variantsGrid.className = "length-variants-grid";

  const perMeterPrice = getPerMeterPriceForPattern(width, depth, pattern);

  availableLengthIds.forEach((lengthId) => {
    const lengthMeta = GRATE_CONFIG.fields.length.meta[lengthId];
    const variantCard = document.createElement("div");
    variantCard.className = "length-variant-card";

    // Length label
    const lengthLabel = document.createElement("div");
    lengthLabel.className = "variant-length-label";
    lengthLabel.textContent = lengthMeta.label;
    variantCard.appendChild(lengthLabel);

    // Quantity selector
    const qtyContainer = document.createElement("div");
    qtyContainer.className = "qty-selector";

    const minusBtn = document.createElement("button");
    minusBtn.className = "qty-btn qty-minus";
    minusBtn.textContent = "-";
    minusBtn.type = "button";

    const qtyInput = document.createElement("input");
    qtyInput.type = "number";
    qtyInput.className = "qty-input";
    qtyInput.value = "1";
    qtyInput.min = "1";
    qtyInput.max = "999";

    const plusBtn = document.createElement("button");
    plusBtn.className = "qty-btn qty-plus";
    plusBtn.textContent = "+";
    plusBtn.type = "button";

    minusBtn.addEventListener("click", () => {
      const current = parseInt(qtyInput.value) || 1;
      if (current > 1) qtyInput.value = current - 1;
    });

    plusBtn.addEventListener("click", () => {
      const current = parseInt(qtyInput.value) || 1;
      qtyInput.value = current + 1;
    });

    qtyContainer.appendChild(minusBtn);
    qtyContainer.appendChild(qtyInput);
    qtyContainer.appendChild(plusBtn);
    variantCard.appendChild(qtyContainer);

    // Price per unit
    const unitPrice = calculateLengthVariantPrice(lengthId, perMeterPrice);
    const priceLabel = document.createElement("div");
    priceLabel.className = "variant-price";
    if (unitPrice) {
      priceLabel.textContent = `$${unitPrice.toFixed(2)}`;
    }
    variantCard.appendChild(priceLabel);

    // Add button
    const addBtn = document.createElement("button");
    addBtn.className = "btn btn-secondary";
    addBtn.textContent = "Add";
    addBtn.type = "button";

    addBtn.addEventListener("click", () => {
      const qty = parseInt(qtyInput.value) || 1;
      addLengthVariantToCart(lengthId, qty, perMeterPrice);
      qtyInput.value = "1"; // Reset quantity
      renderSidebar();
    });

    variantCard.appendChild(addBtn);
    variantsGrid.appendChild(variantCard);
  });

  variantsContainer.appendChild(variantsGrid);
  stepSection.querySelector(`#step-${step.order}-content`).appendChild(variantsContainer);
}

function getAddedLengthQuantity(lengthId) {
  const existing = state.addedLengths.find(item => item.lengthId === lengthId);
  return existing ? existing.quantity : 0;
}

function removeLengthVariantFromCart(lengthId, quantity) {
  const existing = state.addedLengths.find(item => item.lengthId === lengthId);
  
  if (existing) {
    existing.quantity -= quantity;
    if (existing.quantity <= 0) {
      // Remove item completely if quantity becomes 0 or less
      state.addedLengths = state.addedLengths.filter(item => item.lengthId !== lengthId);
    }
  }
  
  // Update sidebar and re-render all steps to update summary
  renderSidebar();
  renderAllSteps();
}

function showToast(message) {
  let toast = document.getElementById('notification-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'notification-toast';
    toast.className = 'notification-toast';
    document.body.appendChild(toast);
  }
  
  toast.textContent = message;
  toast.classList.add('show');
  
  setTimeout(() => {
    toast.classList.remove('show');
  }, 2000);
}

function addLengthVariantToCart(lengthId, quantity, perMeterPrice) {
  // Check if this length is already in cart
  const existing = state.addedLengths.find(item => item.lengthId === lengthId);
  
  if (existing) {
    // Update quantity
    existing.quantity += quantity;
  } else {
    // Add new item
    const unitPrice = calculateLengthVariantPrice(lengthId, perMeterPrice);
    state.addedLengths.push({
      lengthId,
      quantity,
      perMeterPrice,
      unitPrice
    });
  }
  
  showToast(`Added to cart`);
  
  // Update sidebar and re-render all steps to update summary
  renderSidebar();
  renderAllSteps();
}

function changeAccessoryQty(accessoryId, delta) {
  const qtyInput = document.getElementById(`qty-${accessoryId}`);
  if (!qtyInput) return;
  
  const current = parseInt(qtyInput.value) || 1;
  const newValue = current + delta;
  
  if (newValue >= 1) {
    qtyInput.value = newValue;
  }
}

function getAddedAccessoryQuantity(accessoryId) {
  const item = state.addedAccessories.find(a => a.accessory === accessoryId);
  return item ? item.quantity : 0;
}

function removeAccessoryFromCart(accessoryId, variantId, imgUrl) {
  const qtyInput = document.getElementById(`qty-${accessoryId}`);
  if (!qtyInput) return;
  
  const quantity = parseInt(qtyInput.value) || 1;
  const itemIndex = state.addedAccessories.findIndex(
    item => item.accessory === accessoryId
  );
  
  if (itemIndex > -1) {
    const currentQty = state.addedAccessories[itemIndex].quantity;
    
    if (currentQty > quantity) {
      state.addedAccessories[itemIndex].quantity -= quantity;
    } else {
      state.addedAccessories.splice(itemIndex, 1);
    }
  }
  
  qtyInput.value = "1";
  const contentArea = document.getElementById("step-4-content");
  renderAccessoriesStep(null, contentArea);
  renderSidebar();
  renderAllSteps();
}

function addAccessoryToCart(accessoryId, variantId, name, imgUrl, price) {
  const qtyInput = document.getElementById(`qty-${accessoryId}`);
  if (!qtyInput) return;
  
  const quantity = parseInt(qtyInput.value) || 1;
  const existingIndex = state.addedAccessories.findIndex(
    item => item.accessory === accessoryId
  );
  
  if (existingIndex > -1) {
    state.addedAccessories[existingIndex].quantity += quantity;
  } else {
    state.addedAccessories.push({
      accessory: accessoryId,
      variant_id: variantId,
      name: name,
      img_url: imgUrl,
      price: price,
      quantity: quantity
    });
  }
  
  showToast(`✓ Added to cart`);
  
  qtyInput.value = "1";
  const contentArea = document.getElementById("step-4-content");
  renderAccessoriesStep(null, contentArea);
  renderSidebar();
  renderAllSteps();
}

function addAccessoryToCartSingle(accessoryId, variantId, name, imgUrl, price) {
  const existingIndex = state.addedAccessories.findIndex(
    item => item.accessory === accessoryId
  );
  
  if (existingIndex > -1) {
    state.addedAccessories[existingIndex].quantity += 1;
  } else {
    state.addedAccessories.push({
      accessory: accessoryId,
      variant_id: variantId,
      name: name,
      img_url: imgUrl,
      price: price,
      quantity: 1
    });
  }
  
  showToast(`✓ Added to cart`);
  
  const qtyDisplay = document.getElementById(`qty-display-${accessoryId}`);
  if (qtyDisplay) {
    qtyDisplay.textContent = getAddedAccessoryQuantity(accessoryId);
  }
  
  renderSidebar();
}

function removeAccessoryFromCartSingle(accessoryId) {
  const currentQty = getAddedAccessoryQuantity(accessoryId);
  if (currentQty > 0) {
    const existingIndex = state.addedAccessories.findIndex(
      item => item.accessory === accessoryId
    );
    
    if (existingIndex > -1) {
      state.addedAccessories[existingIndex].quantity -= 1;
      
      if (state.addedAccessories[existingIndex].quantity <= 0) {
        state.addedAccessories.splice(existingIndex, 1);
      }
    }
    
    const qtyDisplay = document.getElementById(`qty-display-${accessoryId}`);
    if (qtyDisplay) {
      qtyDisplay.textContent = getAddedAccessoryQuantity(accessoryId);
    }
    
    renderSidebar();
  }
}

function setupHolesawVariantListeners() {
  const variantSelect = document.getElementById('holesaw-variant-select');
  const minusBtn = document.querySelector('[data-holesaw-minus]');
  const plusBtn = document.querySelector('[data-holesaw-plus]');

  if (variantSelect) {
    variantSelect.addEventListener('change', (e) => {
      const newVariantId = e.target.value;
      state.holesawVariantSelected = newVariantId;
      
      // Update the hidden inputs, qty display, and price
      const qtyDisplay = document.getElementById('holesaw-qty-display');
      const priceDisplay = document.getElementById('holesaw-price-display');
      const hiddenVariantInput = document.getElementById('holesaw-variant-hidden');
      const hiddenPriceInput = document.getElementById('holesaw-price-hidden');
      const hiddenVariantIdInput = document.getElementById('holesaw-variant-id-hidden');
      
      const variantInfo = getHolesawVariantInfo(newVariantId);
      const newQty = getHolesawVariantQuantity(newVariantId);
      
      if (qtyDisplay) qtyDisplay.textContent = newQty;
      if (priceDisplay) priceDisplay.textContent = formatCurrency(variantInfo.price);
      if (hiddenVariantInput) hiddenVariantInput.value = newVariantId;
      if (hiddenPriceInput) hiddenPriceInput.value = variantInfo.price;
      if (hiddenVariantIdInput) hiddenVariantIdInput.value = variantInfo.variantId;
      
      // Re-render sidebar to reflect variant change
      renderSidebar();
    });
  }

  if (minusBtn) {
    minusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      removeHolesawVariant();
    });
  }

  if (plusBtn) {
    plusBtn.addEventListener('click', (e) => {
      e.preventDefault();
      addHolesawVariant();
    });
  }
}

function addHolesawVariant() {
  const currentVariantId = state.holesawVariantSelected;
  const variantInfo = getHolesawVariantInfo(currentVariantId);
  
  const existingIndex = state.addedAccessories.findIndex(
    item => item.accessory === "holesaw" && item.variantId === currentVariantId
  );
  
  if (existingIndex > -1) {
    state.addedAccessories[existingIndex].quantity += 1;
  } else {
    state.addedAccessories.push({
      accessory: "holesaw",
      variantId: currentVariantId,
      name: `Holesaw`,
      price: variantInfo.price,
      quantity: 1,
      variant_id: variantInfo.variantId,
      img_url: document.getElementById('holesaw-img-url-hidden')?.value || ''
    });
  }

  // Update display
  const qtyDisplay = document.getElementById('holesaw-qty-display');
  if (qtyDisplay) {
    qtyDisplay.textContent = getHolesawVariantQuantity(currentVariantId);
  }

  showToast('✓ Added to cart');
  renderSidebar();
}

function removeHolesawVariant() {
  const currentVariantId = state.holesawVariantSelected;
  const currentQty = getHolesawVariantQuantity(currentVariantId);
  
  if (currentQty > 0) {
    const itemIndex = state.addedAccessories.findIndex(
      item => item.accessory === "holesaw" && item.variantId === currentVariantId
    );
    
    if (itemIndex > -1) {
      if (state.addedAccessories[itemIndex].quantity > 1) {
        state.addedAccessories[itemIndex].quantity -= 1;
      } else {
        state.addedAccessories.splice(itemIndex, 1);
      }
    }
  }

  // Update display
  const qtyDisplay = document.getElementById('holesaw-qty-display');
  if (qtyDisplay) {
    qtyDisplay.textContent = getHolesawVariantQuantity(currentVariantId);
  }

  renderSidebar();
}

function renderFieldStep(step, contentArea) {
  const selections = state.selections;
  const options = getAvailableOptionsForStep(step, selections);

  const list = document.createElement("div");
  list.className = "option-list";

  if (options.length === 0) {
    const hint = document.createElement("p");
    hint.className = "field-hint";
    hint.textContent = "No options are available for the current selection.";
    contentArea.appendChild(hint);
    return;
  }

  const selectedValue = selections[step.field];

  if (step.type === "singleChoice") {
    options.forEach((opt) => {
      const pill = document.createElement("label");
      pill.className = "option-pill";

      const input = document.createElement("input");
      input.type = "radio";
      input.name = step.field;
      input.value = opt.id;
      input.checked = selectedValue === opt.id;

      if (opt.locked) input.disabled = true;

      input.addEventListener("change", () => {
        onSelectionChange(step, opt.id);
      });

      if (step.showThumbnails) {
        pill.classList.add("option-pill--pattern");
        const inner = document.createElement("div");
        inner.className = "pattern-card";

        const thumbWrapper = document.createElement("div");
        thumbWrapper.className = "pattern-thumb";

        const img = document.createElement("img");
        img.src = opt.thumbnail;
        img.alt = opt.label + " thumbnail";

        thumbWrapper.appendChild(img);

        const textWrap = document.createElement("div");
        const main = document.createElement("div");
        main.className = "pattern-text-main";
        main.textContent = opt.label;
        const sub = document.createElement("div");
        sub.className = "pattern-text-sub";
        sub.textContent = "Pattern option";

        textWrap.appendChild(main);
        textWrap.appendChild(sub);

        inner.appendChild(thumbWrapper);
        inner.appendChild(textWrap);

        pill.appendChild(input);
        pill.appendChild(inner);
      } else {
        const span = document.createElement("span");
        span.className = "option-pill__label";
        span.textContent = opt.label;

        pill.appendChild(input);
        pill.appendChild(span);
      }

      if (selectedValue === opt.id) {
        pill.classList.add("option-pill--selected");
      }

      pill.addEventListener("click", () => {
        if (opt.locked) return;
        onSelectionChange(step, opt.id);
      });

      list.appendChild(pill);
    });
  } else if (step.type === "multiChoice") {
    const selectedItems = Array.isArray(selectedValue) ? selectedValue : [];
    options.forEach((opt) => {
      const pill = document.createElement("label");
      pill.className = "option-pill checkbox-pill";

      const input = document.createElement("input");
      input.type = "checkbox";
      input.name = step.field;
      input.value = opt.id;
      input.checked = selectedItems.includes(opt.id);

      input.addEventListener("change", () => {
        const newArray = toggleArrayValue(
          state.selections[step.field] || [],
          opt.id
        );
        onSelectionChange(step, newArray);
      });

      const span = document.createElement("span");
      span.className = "option-pill__label";
      span.textContent = opt.label;

      pill.appendChild(input);
      pill.appendChild(span);

      if (selectedItems.includes(opt.id)) {
        pill.classList.add("option-pill--selected");
      }

      list.appendChild(pill);
    });
  }

  contentArea.appendChild(list);
}

function renderSummaryStep(step, contentArea) {
  const selections = state.selections;

  const reviewList = document.createElement("div");
  reviewList.className = "review-list";

  const fieldsForSummary = [
    { label: "Width", field: "width", stepId: "width" },
    { label: "Depth", field: "depth", stepId: "depth" },
    { label: "Pattern", field: "pattern", stepId: "pattern" },
    { label: "Lengths", field: "addedLengths", stepId: "pattern" },
    { label: "Accessories", field: "accessories", stepId: "accessories" }
  ];

  fieldsForSummary.forEach((item) => {
    const row = document.createElement("div");
    row.className = "review-row";

    const label = document.createElement("div");
    label.className = "review-row__label";
    label.textContent = item.label;

    const valueEl = document.createElement("div");
    valueEl.className = "review-row__value";
    
    if (item.field === "addedLengths") {
      valueEl.textContent = summarizeAddedLengths();
    } else {
      valueEl.textContent = summariseFieldValue(item.field, selections);
    }

    const editBtn = document.createElement("button");
    editBtn.type = "button";
    editBtn.className = "review-row__edit";

    const icon = document.createElement("span");
    icon.className = "review-row__edit-icon";
    icon.textContent = "✎";

    const text = document.createElement("span");
    text.textContent = "Edit";

    editBtn.appendChild(icon);
    editBtn.appendChild(text);

    editBtn.addEventListener("click", () => {
      let targetStep = item.stepId;
      
      // Override step for specific fields
      if (item.field === "depth") {
        targetStep = "width"; // Depth edit goes to Step 1
      } else if (item.field === "addedLengths") {
        targetStep = "length"; // Length edit goes to Step 3
      }
      
      const targetOrder = GRATE_CONFIG.steps.find(s => s.id === targetStep)?.order;
      const targetSection = document.querySelector(`[data-step="${targetOrder}"]`);
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: "smooth" });
      }
    });

    row.appendChild(label);
    row.appendChild(valueEl);
    row.appendChild(editBtn);

    reviewList.appendChild(row);
  });

  contentArea.appendChild(reviewList);
}

function summarizeAddedLengths() {
  if (state.addedLengths.length === 0) return "—";
  return state.addedLengths
    .map(item => {
      const meta = GRATE_CONFIG.fields.length.meta[item.lengthId];
      return `${meta.label} x ${item.quantity}`;
    })
    .join(" + ");
}

function summariseFieldValue(field, selections) {
  switch (field) {
    case "width":
      return selections.width || "—";
    case "depth":
      return selections.depth || "—";
    case "pattern":
      if (!selections.pattern) return "—";
      return getPatternMeta(selections.pattern).label;
    case "length":
      return selections.length || "—";
    case "accessories":
      if (state.addedAccessories.length > 0) {
        return state.addedAccessories
          .map(item => {
            return `${item.name} x ${item.quantity}`;
          })
          .join(" + ");
      }
      return "None";
    default:
      return "—";
  }
}

function toggleArrayValue(arr, value) {
  const set = new Set(arr);
  if (set.has(value)) {
    set.delete(value);
  } else {
    set.add(value);
  }
  return Array.from(set);
}

// --- Sidebar (visual + running summary) ----

function renderSidebar() {
    const selections = state.selections;

    if(selections.width && selections.depth) {
        if(GRATE_CONFIG.fields.depth.imageUrls[`${selections.width}|${selections.depth}`]){
            let imgSrc = document.createElement("img");
            imgSrc.src = GRATE_CONFIG.fields.depth.imageUrls[`${selections.width}|${selections.depth}`];
            imgSrc.alt = `Diagram for ${selections.width} width and ${selections.depth} depth`;
            imgSrc.className = "size-visual"
            visualdiagram.innerHTML = "";
            visualdiagram.appendChild(imgSrc);
        }else{
            let imgSrc = document.createElement("img");
            imgSrc.src = 'https://cdn.shopify.com/s/files/1/0610/1011/6826/files/no_dimensions.png?v=1765015373';
            imgSrc.alt = `Placeholder diagram`;
            imgSrc.className = "size-visual"
            visualdiagram.innerHTML = "";
            visualdiagram.appendChild(imgSrc);
        }
    }else{
        let imgSrc = document.createElement("img");
        imgSrc.src = 'https://cdn.shopify.com/s/files/1/0610/1011/6826/files/no_dimensions.png?v=1765015373';
        imgSrc.alt = `Placeholder diagram`;
        imgSrc.className = "size-visual"
        visualdiagram.innerHTML = "";
        visualdiagram.appendChild(imgSrc);

    }
  // visual labels
  //   visualWidth.innerHTML = `<p>${selections.width
  //     ? selections.width
  //     : "Width"}</p>`;
  //   visualDepth.innerHTML = `<p>${selections.depth
  //     ? selections.depth
  //     : "Depth"}</p>`;

  // Show selected options only if selections have been made
  summaryListEl.innerHTML = "";
  
  // Only show selected options if width/depth or pattern is selected
  if (selections.width || selections.depth || selections.pattern) {
    const selectedOptionsContainer = document.createElement("div");
    selectedOptionsContainer.className = "sidebar-selected-options";
    
    let selectedOptionsHTML = "";
    
    // Show width only if selected
    if(!selections.pattern){
      if (selections.width) {
        selectedOptionsHTML += `
          <div class="selected-option">
            <span class="option-label">Width:</span>
            <span class="option-value">${state.groupedWidth || selections.width}</span>
          </div>
        `;
      }
      
      // Show depth only if selected
      if (selections.depth) {
        selectedOptionsHTML += `
          <div class="selected-option">
            <span class="option-label">Depth:</span>
            <span class="option-value">${state.groupedDepth || selections.depth}</span>
          </div>
        `;
      }
    }else{
      let patternMap = {}
      let widthsToCheck = [selections.width];
      if (state.groupedWidth) {
        const groupedWidthOpt = GRATE_CONFIG.fields.width.options.find(
          (o) => o.id === state.groupedWidth
        );
        if (groupedWidthOpt && groupedWidthOpt.merged) {
          widthsToCheck = groupedWidthOpt.merged;
        }
      }
      
      // Determine actual depths to use
      let depthsToCheck = [selections.depth];
      if (state.groupedDepth) {
        const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
          (d) => d.id === state.groupedDepth
        );
        if (groupedDepthOpt && groupedDepthOpt.merged) {
          depthsToCheck = groupedDepthOpt.merged;
        }
      }
      widthsToCheck.forEach((w) => {
        depthsToCheck.forEach((d) => {
          const key = `${w}|${d}`;
          const list = GRATE_CONFIG.fields.pattern.byWidthDepth[key] || [];
          list.forEach((pid) => {
            // Store first occurrence or update if same pattern appears in multiple combos
            if (!patternMap[pid]) {
              patternMap[pid] = {
                meta: getPatternMeta(pid),
                concreteWidth: w,
                concreteDepth: d
              };
            }
          });
        });
      });
      console.log(patternMap);
      console.log('selections.pattren',selections.pattern);
      console.log('patternMap[selections.pattren]',patternMap[selections.pattern]);
      console.log('getPatternMeta(selections.pattern)',getPatternMeta(selections.pattern));
      
      if (selections.width) {
        selectedOptionsHTML += `
          <div class="selected-option">
            <span class="option-label">Width:</span>
            <span class="option-value">${patternMap[selections.pattern].concreteWidth}</span>
          </div>
        `;
      }
      
      // Show depth only if selected
      if (selections.depth) {
        selectedOptionsHTML += `
          <div class="selected-option">
            <span class="option-label">Depth:</span>
            <span class="option-value">${patternMap[selections.pattern].concreteDepth}</span>
          </div>
        `;
      }
      if (selections.pattern) {
        selectedOptionsHTML += `
          <div class="selected-option">
            <span class="option-label">Pattern:</span>
            <span class="option-value">${getPatternMeta(selections.pattern).label}</span>
          </div>
        `;
      }

      
      
    }
    
    // Show pattern only if selected
    // if (selections.pattern) {
    //   selectedOptionsHTML += `
    //     <div class="selected-option">
    //       <span class="option-label">Pattern:</span>
    //       <span class="option-value">${getPatternMeta(selections.pattern).label}</span>
    //     </div>
    //   `;
    // }
    
    selectedOptionsContainer.innerHTML = selectedOptionsHTML;
    summaryListEl.appendChild(selectedOptionsContainer);
  }

  // running summary - show added lengths and accessories
  const itemsContainer = document.createElement("div");
  itemsContainer.className = "sidebar-added-items";
  summaryListEl.appendChild(itemsContainer);
  
  // Add lengths section
  if (state.addedLengths.length > 0) {
    const lengthsHeading = document.createElement("div");
    lengthsHeading.className = "sidebar-section-heading";
    lengthsHeading.textContent = "LENGTHS";
    itemsContainer.appendChild(lengthsHeading);
    state.addedLengths.forEach((item, index) => {
      const lengthMeta = GRATE_CONFIG.fields.length.meta[item.lengthId];
      const itemRow = document.createElement("div");
      itemRow.className = "sidebar-item-row";

      const lengthLabel = document.createElement("span");
      lengthLabel.className = "item-length";
      lengthLabel.textContent = lengthMeta.label;

      const qtyControls = document.createElement("div");
      qtyControls.className = "item-qty-controls";

      const minusBtn = document.createElement("button");
      minusBtn.className = "qty-btn";
      minusBtn.textContent = "-";
      minusBtn.type = "button";
      minusBtn.addEventListener("click", () => {
        if (item.quantity > 1) {
          item.quantity--;
        } else {
          state.addedLengths.splice(index, 1);
        }
        renderSidebar();
        renderAllSteps();
      });

      const qtySpan = document.createElement("span");
      qtySpan.className = "qty-display";
      qtySpan.textContent = item.quantity;

      const plusBtn = document.createElement("button");
      plusBtn.className = "qty-btn";
      plusBtn.textContent = "+";
      plusBtn.type = "button";
      plusBtn.addEventListener("click", () => {
        item.quantity++;
        renderSidebar();
        renderAllSteps();
      });

      qtyControls.appendChild(minusBtn);
      qtyControls.appendChild(qtySpan);
      qtyControls.appendChild(plusBtn);

      const itemPrice = document.createElement("span");
      itemPrice.className = "item-price";
      itemPrice.textContent = formatCurrency(item.unitPrice * item.quantity);

      const removeBtn = document.createElement("button");
      removeBtn.className = "item-remove-btn";
      removeBtn.textContent = "X";
      removeBtn.type = "button";
      removeBtn.addEventListener("click", () => {
        state.addedLengths.splice(index, 1);
        renderSidebar();
        renderAllSteps();
      });

      itemRow.appendChild(lengthLabel);
      itemRow.appendChild(qtyControls);
      itemRow.appendChild(itemPrice);
      itemRow.appendChild(removeBtn);
      itemsContainer.appendChild(itemRow);
    });
  }
  
  // Add accessories section
  if (state.addedAccessories && state.addedAccessories.length > 0) {
    const accessoriesHeading = document.createElement("div");
    accessoriesHeading.className = "sidebar-section-heading";
    accessoriesHeading.textContent = "ACCESSORIES";
    itemsContainer.appendChild(accessoriesHeading);
    state.addedAccessories.forEach((item, index) => {
      const itemRow = document.createElement("div");
      itemRow.className = "sidebar-item-row";

      const accessoryLabel = document.createElement("span");
      accessoryLabel.className = "item-accessory";
      
      // For holesaw, show variant info
      if (item.accessory === 'holesaw' && item.variantId) {
        const variantInfo = getHolesawVariantInfo(item.variantId);
        accessoryLabel.textContent = `${item.name} ${variantInfo.label}`;
      } else {
        accessoryLabel.textContent = item.name;
      }

      const qtyControls = document.createElement("div");
      qtyControls.className = "item-qty-controls";

      const minusBtn = document.createElement("button");
      minusBtn.className = "qty-btn";
      minusBtn.textContent = "-";
      minusBtn.type = "button";
      minusBtn.addEventListener("click", () => {
        if (item.quantity > 1) {
          item.quantity--;
        } else {
          state.addedAccessories.splice(index, 1);
        }
        renderSidebar();
        renderAllSteps();
      });

      const qtySpan = document.createElement("span");
      qtySpan.className = "qty-display";
      qtySpan.textContent = item.quantity;

      const plusBtn = document.createElement("button");
      plusBtn.className = "qty-btn";
      plusBtn.textContent = "+";
      plusBtn.type = "button";
      plusBtn.addEventListener("click", () => {
        item.quantity++;
        renderSidebar();
        renderAllSteps();
      });

      qtyControls.appendChild(minusBtn);
      qtyControls.appendChild(qtySpan);
      qtyControls.appendChild(plusBtn);

      const itemPrice = document.createElement("span");
      itemPrice.className = "item-price";
      itemPrice.textContent = formatCurrency(item.price * item.quantity);

      const removeBtn = document.createElement("button");
      removeBtn.className = "item-remove-btn";
      removeBtn.textContent = "X";
      removeBtn.type = "button";
      removeBtn.addEventListener("click", () => {
        state.addedAccessories.splice(index, 1);
        renderSidebar();
        renderAllSteps();
      });

      itemRow.appendChild(accessoryLabel);
      itemRow.appendChild(qtyControls);
      itemRow.appendChild(itemPrice);
      itemRow.appendChild(removeBtn);
      itemsContainer.appendChild(itemRow);
    });
  }
  
  if (state.addedLengths.length > 0 || state.addedAccessories.length > 0) {
    summaryListEl.appendChild(itemsContainer);
  } else {
    const emptyMsg = document.createElement("p");
    emptyMsg.className = "field-hint";
    emptyMsg.textContent = "No items added yet";
    summaryListEl.appendChild(emptyMsg);
  }

  // Update price breakdown
  const breakdown = calculatePriceBreakdown();
  const gratesEl = document.querySelector("[data-breakdown-grates]");
  const accessoriesEl = document.querySelector("[data-breakdown-accessories]");
  
  if (gratesEl) gratesEl.textContent = formatCurrency(breakdown.gratesTotal);
  if (accessoriesEl) accessoriesEl.textContent = formatCurrency(breakdown.accessoriesTotal);
  
  const totalPrice = calculateTotalPrice();
  if (totalPrice != null) {
    summaryTotalEl.textContent = formatCurrency(totalPrice);
    sidebarErrorEl.textContent = "";
  } else {
    summaryTotalEl.textContent = formatCurrency(0);
    sidebarErrorEl.textContent = "";
  }

  // Update sidebar add button - enable if at least one length is added
  sidebarAddBtn.disabled = state.addedLengths.length === 0;
  sidebarSaveBtn.disabled = state.addedLengths.length === 0;
  sidebarSaveAndContinueBtn.disabled = state.addedLengths.length === 0;
}

// --- Event handlers ---

// --- Event handlers ---

function onSelectionChange(step, valueOrArray) {
  if (!step.field) return;

  if (step.type === "multiChoice") {
    state.selections[step.field] = Array.isArray(valueOrArray)
      ? valueOrArray
      : [];
  } else {
    state.selections[step.field] = valueOrArray;
  }

  const stepIndex = GRATE_CONFIG.steps.findIndex(
    (s) => s.id === step.id
  );
  applyDerivedSelectionsFromStepIndex(stepIndex);

  renderAllSteps();
  renderSidebar();
}

// --- Checkout Modal Functions ---

function createCheckoutModal() {
  // Check if modal already exists
  if (document.getElementById("checkout-modal-overlay")) return;

  const modalHTML = `
    <div id="checkout-modal-overlay" class="checkout-modal-overlay">
      <div class="checkout-modal">
        <div class="checkout-modal-header">
          <h2>Shipping Information</h2>
          <button type="button" class="checkout-modal-close" id="checkout-modal-close">&times;</button>
        </div>
        
        <form id="checkout-form" class="checkout-form">
          <div class="form-row">
            <div class="form-group">
              <label for="firstName">First Name *</label>
              <input type="text" id="firstName" name="firstName" required>
              <span class="error-message" id="firstName-error"></span>
            </div>
            <div class="form-group">
              <label for="lastName">Last Name *</label>
              <input type="text" id="lastName" name="lastName" required>
              <span class="error-message" id="lastName-error"></span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="email">Email Address *</label>
              <input type="email" id="email" name="email" required>
              <span class="error-message" id="email-error"></span>
            </div>
            <div class="form-group">
              <label for="phone">Phone Number *</label>
              <input type="tel" id="phone" name="phone" required>
              <span class="error-message" id="phone-error"></span>
            </div>
          </div>
          <div class="form-group">
            <label for="companyName">Company Name *</label>
            <input type="text" id="companyName" name="companyName" required>
            <span class="error-message" id="companyName-error"></span>
          </div>


          <button type="button" id="checkout-proceed-btn" class="btn btn-primary">Proceed to Checkout</button>
        </form>

        <div id="checkout-error" class="checkout-error" style="display: none;">
          <p id="checkout-error-message"></p>
          <button type="button" id="checkout-error-retry-btn" class="btn btn-secondary">Try Again</button>
        </div>

        <div id="checkout-loader" class="checkout-loader" style="display: none;">
          <div class="spinner"></div>
          <p>Please wait...</p>
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);
  setupModalEventListeners();
}
function createSaveModal() {
  // Check if modal already exists
  if (document.getElementById("save-modal-overlay")) return;

  const modalHTML = `
    <div id="save-modal-overlay" class="checkout-modal-overlay">
      <div class="checkout-modal">
        <div class="checkout-modal-header">
          <h2>Shipping Information</h2>
          <button type="button" class="checkout-modal-close" id="save-modal-close">&times;</button>
        </div>
        
        <form id="save-form" class="checkout-form">
          <div class="form-row">
            <div class="form-group">
              <label for="firstName-save">First Name *</label>
              <input type="text" id="firstName-save" name="firstName-save" required>
              <span class="error-message" id="firstName-save-error"></span>
            </div>
            <div class="form-group">
              <label for="lastName-save">Last Name *</label>
              <input type="text" id="lastName-save" name="lastName-save" required>
              <span class="error-message" id="lastName-save-error"></span>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="email-save">Email Address *</label>
              <input type="email" id="email-save" name="email" required>
              <span class="error-message" id="email-save-error"></span>
            </div>
            <div class="form-group">
              <label for="phone-save">Phone Number *</label>
              <input type="tel" id="phone-save" name="phone" required>
              <span class="error-message" id="phone-save-error"></span>
            </div>
          </div>
          <div class="form-group">
            <label for="companyName-save">Company Name *</label>
            <input type="text" id="companyName-save" name="companyName-save" required>
            <span class="error-message" id="companyName-save-error"></span>
          </div>
          <div class="form-group pickerContainer">
            <label for="whenRequired-save">When do you require the material? *</label>
            <input id="whenRequired-save" name="whenRequired-save" data-toggle="datepicker" required>
            <span class="error-message" id="whenRequired-save-error"></span>
          </div>

          <button type="button" id="save-proceed-btn" class="btn btn-primary">Save</button>
        </form>

        <div id="save-error" class="checkout-error" style="display: none;">
          <p id="save-error-message"></p>
          <button type="button" id="save-error-retry-btn" class="btn btn-secondary">Try Again</button>
        </div>

        <div id="save-loader" class="checkout-loader" style="display: none;">
          <div class="spinner"></div>
          <p>Please wait...</p>
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);
  setupSaveModalEventListeners();
}

function setupModalEventListeners() {
  const modal = document.getElementById("checkout-modal-overlay");
  const closeBtn = document.getElementById("checkout-modal-close");
  const proceedBtn = document.getElementById("checkout-proceed-btn");
  const retryBtn = document.getElementById("checkout-error-retry-btn");

  // Close modal on X button
  closeBtn.addEventListener("click", () => closeCheckoutModal());

  // Close modal on overlay click
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeCheckoutModal();
    }
  });

  // Proceed to checkout
  proceedBtn.addEventListener("click", (e) => {
    e.preventDefault();
    validateAndSubmitCheckout();
  });

  // Retry button
  if (retryBtn) {
    retryBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const errorDiv = document.getElementById("checkout-error");
      const form = document.getElementById("checkout-form");
      errorDiv.style.display = "none";
      form.style.display = "block";
    });
  }

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.style.display !== "none") {
      closeCheckoutModal();
    }
  });
}
function setupSaveModalEventListeners() {
  const modal = document.getElementById("save-modal-overlay");
  const closeBtn = document.getElementById("save-modal-close");
  const saveBtn = document.getElementById("save-proceed-btn");
  const retryBtn = document.getElementById("save-error-retry-btn");
  jQuery('[data-toggle="datepicker"]').datepicker({
    container: '.pickerContainer',
    autoHide: true,
    startDate: new Date(new Date().setDate(new Date().getDate() + 1)),
    trigger:'#whenRequired-save'
  });
  // Close modal on X button
  closeBtn.addEventListener("click", () => closeSaveModal());

  // Close modal on overlay click
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeSaveModal();
    }
  });

  // Proceed to checkout
  saveBtn.addEventListener("click", (e) => {
    e.preventDefault();
    validateAndSubmitSave();
  });

  // Retry button
  if (retryBtn) {
    retryBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const errorDiv = document.getElementById("save-error");
      const form = document.getElementById("save-form");
      errorDiv.style.display = "none";
      form.style.display = "block";
    });
  }

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.style.display !== "none") {
      closeSaveModal();
    }
  });
}

function openCheckoutModal() {
  const modal = document.getElementById("checkout-modal-overlay");
  if (!modal) {
    createCheckoutModal();
    return openCheckoutModal();
  }
  modal.style.display = "flex";
  jQuery('html').css('overflow','hidden')
  clearCheckoutForm();
  clearFormErrors();
}
function openSaveModal() {
  const modal = document.getElementById("save-modal-overlay");
  if (!modal) {
    createSaveModal();
    return openSaveModal();
  }
  modal.style.display = "flex";
  jQuery('html').css('overflow','hidden')
  clearSaveForm();
  clearFormErrors();
}

function closeCheckoutModal() {
  const modal = document.getElementById("checkout-modal-overlay");
  if (modal) {
    modal.style.display = "none";
    jQuery('html').css('overflow','auto')
  }
}
function closeSaveModal() {
  const modal = document.getElementById("save-modal-overlay");
  if (modal) {
    modal.style.display = "none";
    jQuery('html').css('overflow','auto')
  }
}

function clearCheckoutForm() {
  const form = document.getElementById("checkout-form");
  if (form) form.reset();
}
function clearSaveForm() {
  const form = document.getElementById("save-form");
  if (form) form.reset();
}

function clearFormErrors() {
  document.querySelectorAll(".error-message").forEach((el) => {
    el.textContent = "";
  });
}

function validateCheckoutForm() {
  clearFormErrors();
  let isValid = true;

  const firstName = document.getElementById("firstName").value.trim();
  const lastName = document.getElementById("lastName").value.trim();
  const companyName = document.getElementById("companyName").value.trim();
  const email = document.getElementById("email").value.trim();
  const phone = document.getElementById("phone").value.trim();
  // const state__territory = document.getElementById("state__territory").value.trim();

  // First Name validation
  if (!firstName) {
    document.getElementById("firstName-error").textContent = "First Name is required";
    isValid = false;
  }

  // Last Name validation
  if (!lastName) {
    document.getElementById("lastName-error").textContent = "Last Name is required";
    isValid = false;
  }
  // Company Name validation
  if (!companyName) {
    document.getElementById("companyName-error").textContent = "Company Name is required";
    isValid = false;
  }

  // Email validation
  if (!email) {
    document.getElementById("email-error").textContent = "Email is required";
    isValid = false;
  } else if (!isValidEmail(email)) {
    document.getElementById("email-error").textContent = "Please enter a valid email";
    isValid = false;
  }

  // Phone validation
  if (!phone) {
    document.getElementById("phone-error").textContent = "Phone Number is required";
    isValid = false;
  }

  // Phone validation
  // if (!state__territory) {
  //   document.getElementById("state__territory-error").textContent = "State / Territory is required";
  //   isValid = false;
  // }

  return isValid;
}
function validateSaveForm() {
  clearFormErrors();
  let isValid = true;

  const firstName = document.getElementById("firstName-save").value.trim();
  const lastName = document.getElementById("lastName-save").value.trim();
  const companyName = document.getElementById("companyName-save").value.trim();
  const email = document.getElementById("email-save").value.trim();
  const phone = document.getElementById("phone-save").value.trim();
  // const state__territory = document.getElementById("state__territory-save").value.trim();
  const when_required = document.getElementById("whenRequired-save").value.trim();

  // First Name validation
  if (!firstName) {
    document.getElementById("firstName-save-error").textContent = "First Name is required";
    isValid = false;
  }

  // Last Name validation
  if (!lastName) {
    document.getElementById("lastName-save-error").textContent = "Last Name is required";
    isValid = false;
  }
  // Company Name validation
  if (!companyName) {
    document.getElementById("companyName-save-error").textContent = "Company Name is required";
    isValid = false;
  }

  // Email validation
  if (!email) {
    document.getElementById("email-save-error").textContent = "Email is required";
    isValid = false;
  } else if (!isValidEmail(email)) {
    document.getElementById("email-save-error").textContent = "Please enter a valid email";
    isValid = false;
  }

  // Phone validation
  if (!phone) {
    document.getElementById("phone-save-error").textContent = "Phone Number is required";
    isValid = false;
  }
  // if (!state__territory) {
  //   document.getElementById("state__territory-save-error").textContent = "State / Territory is required";
  //   isValid = false;
  // }
  if (!when_required) {
    document.getElementById("whenRequired-save-error").textContent = "Date is required";
    isValid = false;
  }else{
    let currentDate = new Date()
    let fDate = new Date(document.getElementById("whenRequired-save").value.trim())
    if(fDate == 'Invalid Date'){
      document.getElementById("whenRequired-save-error").textContent = "Please provide a valid date";
      isValid = false;
    }else{
      if(currentDate >= fDate){
        document.getElementById("whenRequired-save-error").textContent = "Please provide a future date";
        isValid = false;
      }
    }
  }

  return isValid;
}

function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

function transformAddedLengthsWithVariants() {
  // Transform addedLengths array into nested object organized by pattern with product/variant IDs
  const transformed = {};

  state.addedLengths.forEach((item) => {
    const { pattern } = state.selections;
    const { width, depth } = state.selections;
    const { lengthId, quantity, perMeterPrice, unitPrice } = item;

    // Get pattern data from PRODUCT_VARIANT_MAP
    const patternData = PRODUCT_VARIANT_MAP.patterns[pattern];
    if (!patternData) return; // Skip if pattern not found

    // Build arrays of widths and depths to check for variant lookup
    let widthsToCheck = [width];
    let depthsToCheck = [depth];

    // If grouped width, add all concrete widths
    if (state.groupedWidth) {
      const groupedWidthOpt = GRATE_CONFIG.fields.width.options.find(
        (o) => o.id === state.groupedWidth
      );
      if (groupedWidthOpt && groupedWidthOpt.merged) {
        widthsToCheck = groupedWidthOpt.merged;
      }
    }

    // If grouped depth, add all concrete depths
    if (state.groupedDepth) {
      const groupedDepthOpt = GRATE_CONFIG.fields.depth.optionsAll.find(
        (d) => d.id === state.groupedDepth
      );
      if (groupedDepthOpt && groupedDepthOpt.merged) {
        depthsToCheck = groupedDepthOpt.merged;
      }
    }

    // Try to find variant ID for ANY combination of widths/depths
    let variantId = null;
    for (let w of widthsToCheck) {
      for (let d of depthsToCheck) {
        const variantKey = `${w}|${d}|${lengthId}`;
        if (patternData.variants[variantKey]) {
          variantId = patternData.variants[variantKey];
          break; // Found it, stop searching
        }
      }
      if (variantId) break; // Exit outer loop if found
    }

    // Initialize pattern object if it doesn't exist
    if (!transformed[pattern]) {
      transformed[pattern] = {
        product_id: patternData.product_id,
      };
    }

    // Add length variant data - use concrete width/depth from state
    transformed[pattern][lengthId] = {
      variant_id: variantId,
      width: width,
      depth: depth,
      quantity: quantity,
      unitPrice: unitPrice,
      perMeterPrice: perMeterPrice
    };
  });

  return transformed;
}
async function createDraftOrder(payload, onSuccess, onError) {
  try {
    // console.log(payload)
    // return
    // 1) Create draft order
    // const draftRes = await fetch("https://0d708064d622.ngrok-free.app/api/draft-order", {
    const draftRes = await fetch("https://buda-backend.vercel.app/api/draft-order", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!draftRes.ok) {
      throw new Error("Network error while creating draft order");
    }

    const res = await draftRes.json();

    if (!res.success) {
      throw new Error(res.error || "Error creating draft order");
    }

    // ✅ Everything succeeded – call your function
    if (typeof onSuccess === "function") {
      onSuccess(res);
    }

  } catch (err) {
    console.error("Request error:", err);
    if (typeof onError === "function") {
      onError(err);
    }
  }
}
async function createSaveDraftOrder(payload, onSuccess, onError) {
  try {
    // console.log(payload)
    // return
    // 1) Create draft order
    // const draftRes = await fetch("https://0d5f60bf149e.ngrok-free.app/api/save-draft-order", {
    const draftRes = await fetch("https://buda-backend.vercel.app/api/save-draft-order", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!draftRes.ok) {
      throw new Error("Network error while creating draft order");
    }

    const res = await draftRes.json();

    if (!res.success) {
      throw new Error(res.error || "Error creating draft order");
    }

    // ✅ Everything succeeded – call your function
    if (typeof onSuccess === "function") {
      onSuccess(res);
    }

  } catch (err) {
    console.error("Request error:", err);
    if (typeof onError === "function") {
      onError(err);
    }
  }
}
async function getCartItemsObject() {
  const response = await fetch('/cart.js');
  const cartData = await response.json();

  let itemsObjs = {};
  if (cartData.item_count > 0) {
    cartData.items.forEach(item => {
      itemsObjs[item.variant_id] = item.quantity;
    });
  }

  return itemsObjs;
}
function clearCart() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: "/cart/clear.js",
      method: "POST",
      contentType: "application/json",
      success: function (res) {
        resolve(res);
      },
      error: function (xhr, status, error) {
        reject(error);
      }
    });
  });
}

async function validateAndSubmitCheckout() {
  if (!validateCheckoutForm()) {
    return;
  }

  // Show loader
  const form = document.getElementById("checkout-form");
  const loader = document.getElementById("checkout-loader");
  jQuery('#checkout-modal-overlay .checkout-modal-header h2').text('Order Processing')
  form.style.display = "none";
  loader.style.display = "flex";

  // Simulate processing for 2 seconds
  // setTimeout(() => {
    // Transform addedLengths to include product and variant IDs
    const transformedLengths = transformAddedLengthsWithVariants();

    const formData = {
      firstName: document.getElementById("firstName").value.trim(),
      lastName: document.getElementById("lastName").value.trim(),
      companyName: document.getElementById("companyName").value.trim(),
      email: document.getElementById("email").value.trim(),
      phone: document.getElementById("phone").value.trim(),
      // state: document.getElementById("state__territory").value.trim(),
      // state_name: jQuery('#state__territory option:selected').text(),
      // streetAddress: document.getElementById("streetAddress").value.trim(),
      // city: document.getElementById("city").value.trim(),
      // state: document.getElementById("state").value.trim(),
      // postcode: document.getElementById("postcode").value.trim(),
      selections: state.selections,
      lineItems: transformedLengths,
      addedAccessories: state.addedAccessories
    };

    // Log to console
    // console.log("Checkout Data:", formData);
    let accessoriesIds = mergeAccessoryConfigs()
    let productIds = mergeProductsConfigs()
    let vpMerged = [...accessoriesIds,...productIds]

    let cartObject = await getCartItemsObject()
    let cartObjectKeys = Object.keys(cartObject)
    cartObjectKeys = cartObjectKeys.length > 0 ? cartObjectKeys.map(v => parseInt(v)) : []

    console.log('cartObject',cartObject)
    console.log('cartObjectKeys',Object.keys(cartObject))

    let lineitems = [];
    Object.keys(formData.lineItems).forEach(patternKey => {
      Object.keys(formData.lineItems[patternKey])
        .filter(lengthKey => lengthKey !== 'product_id') // Filter out product_id
        .forEach(lengthKey => {
          if(cartObjectKeys.includes(parseInt(formData.lineItems[patternKey][lengthKey].variant_id))){
            lineitems.push({
              variant_id: parseInt(formData.lineItems[patternKey][lengthKey].variant_id),
              quantity: formData.lineItems[patternKey][lengthKey].quantity + cartObject[parseInt(formData.lineItems[patternKey][lengthKey].variant_id)],
            });
            delete cartObject[parseInt(formData.lineItems[patternKey][lengthKey].variant_id)]
          }else{
            lineitems.push({
              variant_id: parseInt(formData.lineItems[patternKey][lengthKey].variant_id),
              quantity: formData.lineItems[patternKey][lengthKey].quantity,
            });

          }
        });
    })
    formData.addedAccessories.forEach(acc => {
      if(cartObjectKeys.includes(parseInt(acc.variant_id))){
        lineitems.push({
          variant_id: parseInt(acc.variant_id),
          quantity: acc.quantity + cartObject[parseInt(acc.variant_id)],
        });
        delete cartObject[parseInt(acc.variant_id)]
      }else{
        lineitems.push({
          variant_id: parseInt(acc.variant_id),
          quantity: acc.quantity,
        });
      }
    });

    cartObjectKeys = Object.keys(cartObject)
    cartObjectKeys = cartObjectKeys.length > 0 ? cartObjectKeys.map(v => parseInt(v)) : []

    if(cartObjectKeys.length > 0){
      cartObjectKeys.forEach(cartId => {
        if(vpMerged.includes(cartId)){
          lineitems.push({
            variant_id: cartId,
            quantity: cartObject[cartId],
          });
        }
      });
    }
    await clearCart()


    let shipping_address = {};
    // if (formData.streetAddress) shipping_address.address1 = formData.streetAddress;
    // if (formData.city) shipping_address.city = formData.city;
    if (formData.firstName) shipping_address.first_name = formData.firstName;
    if (formData.lastName) shipping_address.last_name = formData.lastName;
    if (formData.companyName) shipping_address.company = formData.companyName;
    // if (formData.state) shipping_address.province_code = formData.state;
    // if (formData.state_name) shipping_address.province = formData.state_name;
    if (formData.phone) shipping_address.phone = formData.phone;
    shipping_address.country = 'Australia'
    let payload = {
        email: formData.email,
        note: "Customized Grate Order",
        line_items:lineitems,
    }
    // console.log("shipping_address",  Object.keys(shipping_address).length);
    Object.keys(shipping_address).length > 0 ? payload.shipping_address = shipping_address : '';
    console.log("Formatted Payload for Shopify:", payload);
    // return;
    createDraftOrder(payload,function(res){
      // closeCheckoutModal();
      // showThankYouMessage();
      setTimeout(() => {
        res.draft_order.invoice_url ? window.location.href = res.draft_order.invoice_url : '';
      },1000)
    },function(err){
      // Error callback
      const loader = document.getElementById("checkout-loader");
      const errorDiv = document.getElementById("checkout-error");
      const errorMessage = document.getElementById("checkout-error-message");
      
      loader.style.display = "none";
      errorDiv.style.display = "block";
      errorMessage.textContent = "Something went wrong while placing your order. Please try again. If the issue persists, contact our support team.";
    })
    
    // Hide modal, sidebars, and show thank you message
    // setTimeout(() => {
      
    // },2000)
  // }, 2000);
}
async function validateAndSubmitSave() {
  if (!validateSaveForm()) {
    return;
  }

  // Show loader
  const form = document.getElementById("save-form");
  const loader = document.getElementById("save-loader");
  form.style.display = "none";
  loader.style.display = "flex";
  jQuery('#save-modal-overlay .checkout-modal-header h2').text('Order Processing')

  // Simulate processing for 2 seconds
  // setTimeout(() => {
    // Transform addedLengths to include product and variant IDs
    const transformedLengths = transformAddedLengthsWithVariants();

    const formData = {
      firstName: document.getElementById("firstName-save").value.trim(),
      lastName: document.getElementById("lastName-save").value.trim(),
      companyName: document.getElementById("companyName-save").value.trim(),
      email: document.getElementById("email-save").value.trim(),
      phone: document.getElementById("phone-save").value.trim(),
      // state: document.getElementById("state__territory-save").value.trim(),
      // state_name: jQuery('#state__territory-save option:selected').text(),
      when_required: jQuery('#whenRequired-save').val().trim(),
      selections: state.selections,
      lineItems: transformedLengths,
      addedAccessories: state.addedAccessories
    };

    // Log to console
    // console.log("Checkout Data:", formData);

    let accessoriesIds = mergeAccessoryConfigs()
    let productIds = mergeProductsConfigs()
    let vpMerged = [...accessoriesIds,...productIds]

    let cartObject = await getCartItemsObject()
    let cartObjectKeys = Object.keys(cartObject)
    cartObjectKeys = cartObjectKeys.length > 0 ? cartObjectKeys.map(v => parseInt(v)) : []

    console.log('cartObject',cartObject)
    console.log('cartObjectKeys',Object.keys(cartObject))


    // let lineitems = [];
    // Object.keys(formData.lineItems).forEach(patternKey => {
    //   Object.keys(formData.lineItems[patternKey])
    //     .filter(lengthKey => lengthKey !== 'product_id') // Filter out product_id
    //     .forEach(lengthKey => {
    //       lineitems.push({
    //         variant_id: formData.lineItems[patternKey][lengthKey].variant_id,
    //         quantity: formData.lineItems[patternKey][lengthKey].quantity,
    //       });
    //     });
    // })
    // formData.addedAccessories.forEach(acc => {
    //     lineitems.push({
    //         variant_id: acc.variant_id,
    //         quantity: acc.quantity,
    //     });
    // });

    let lineitems = [];
    Object.keys(formData.lineItems).forEach(patternKey => {
      Object.keys(formData.lineItems[patternKey])
        .filter(lengthKey => lengthKey !== 'product_id') // Filter out product_id
        .forEach(lengthKey => {
          if(cartObjectKeys.includes(parseInt(formData.lineItems[patternKey][lengthKey].variant_id))){
            lineitems.push({
              variant_id: parseInt(formData.lineItems[patternKey][lengthKey].variant_id),
              quantity: formData.lineItems[patternKey][lengthKey].quantity + cartObject[parseInt(formData.lineItems[patternKey][lengthKey].variant_id)],
            });
            delete cartObject[parseInt(formData.lineItems[patternKey][lengthKey].variant_id)]
          }else{
            lineitems.push({
              variant_id: parseInt(formData.lineItems[patternKey][lengthKey].variant_id),
              quantity: formData.lineItems[patternKey][lengthKey].quantity,
            });

          }
        });
    })
    formData.addedAccessories.forEach(acc => {
      if(cartObjectKeys.includes(parseInt(acc.variant_id))){
        lineitems.push({
          variant_id: parseInt(acc.variant_id),
          quantity: acc.quantity + cartObject[parseInt(acc.variant_id)],
        });
        delete cartObject[parseInt(acc.variant_id)]
      }else{
        lineitems.push({
          variant_id: parseInt(acc.variant_id),
          quantity: acc.quantity,
        });
      }
    });

    cartObjectKeys = Object.keys(cartObject)
    cartObjectKeys = cartObjectKeys.length > 0 ? cartObjectKeys.map(v => parseInt(v)) : []

    if(cartObjectKeys.length > 0){
      cartObjectKeys.forEach(cartId => {
        if(vpMerged.includes(cartId)){
          lineitems.push({
            variant_id: cartId,
            quantity: cartObject[cartId],
          });
        }
      });
    }
    await clearCart()

    let shipping_address = {};
    // if (formData.streetAddress) shipping_address.address1 = formData.streetAddress;
    // if (formData.city) shipping_address.city = formData.city;
    if (formData.firstName) shipping_address.first_name = formData.firstName;
    if (formData.lastName) shipping_address.last_name = formData.lastName;
    if (formData.companyName) shipping_address.company = formData.companyName;
    // if (formData.state) shipping_address.province_code = formData.state;
    // if (formData.state_name) shipping_address.province = formData.state_name;
    // if (formData.postcode) shipping_address.zip = formData.postcode;
    if (formData.phone) shipping_address.phone = formData.phone;
    shipping_address.country = 'Australia'
    let payload = {
        email: formData.email,
        first_name: formData.firstName,
        last_name: formData.lastName,
        note: `Customized Grate Order\n Material required on: ${formData.when_required}`,
        line_items:lineitems,
    }
    // console.log("shipping_address",  Object.keys(shipping_address).length);
    Object.keys(shipping_address).length > 0 ? payload.shipping_address = shipping_address : '';
    // console.log("Formatted Payload for Shopify:", payload);
    createSaveDraftOrder(payload,function(res){
      closeSaveModal();
      showThankYouMessage();
      // setTimeout(() => {
      //   res.draft_order.invoice_url ? window.location.href = res.draft_order.invoice_url : '';
      // },1000)
    },function(err){
      // Error callback
      const loader = document.getElementById("save-loader");
      const errorDiv = document.getElementById("save-error");
      const errorMessage = document.getElementById("save-error-message");
      
      loader.style.display = "none";
      errorDiv.style.display = "block";
      errorMessage.textContent = "Something went wrong while placing your order. Please try again. If the issue persists, contact our support team.";
    })
    
    // Hide modal, sidebars, and show thank you message
    // setTimeout(() => {
      
    // },2000)
  // }, 2000);
}

function showThankYouMessage() {
  // Hide sidebars and main content
  const sidebar = document.querySelector(".order-summary");
  const mainWrapper = document.querySelector(".order-builder__columns");
  const mainHeader = document.querySelector(".order-builder__header");
  if (sidebar) sidebar.style.display = "none";
  if (mainWrapper) mainWrapper.style.display = "none";
  if (mainHeader) mainHeader.style.display = "none";

  // Show thank you message
  const thankYouHTML = `
    <div class="thank-you-container">
      <div class="thank-you-content">
        <h1>Thank You!</h1>
        <p>Your order has been received.</p>
        <p>We will process your request shortly.</p>
      </div>
    </div>
  `;

  // document.body.insertAdjacentHTML('beforeend', thankYouHTML);
  jQuery('.order-builder-main-wrapper').append(thankYouHTML)
  jQuery('html, body').animate({ scrollTop: 0 }, 600);

  // Start over button
  // document.getElementById("start-over-btn").addEventListener("click", () => {
  //   location.reload();
  // });
}

function validateCartRequirements() {
  const { width, depth, pattern } = state.selections;
  
  // Check if all required selections are made
  if (!width) {
    return { valid: false, message: "Please select width and depth" };
  }
  if (!depth) {
    return { valid: false, message: "Please select width and depth" };
  }
  if (!pattern) {
    return { valid: false, message: "Please select a pattern" };
  }
  if (state.addedLengths.length === 0) {
    return { valid: false, message: "Please add at least one length" };
  }

  return { valid: true, message: "" };
}
async function addToCartAndContinue(){
  const transformedLengths = transformAddedLengthsWithVariants();

  const formData = {
    selections: state.selections,
    lineItems: transformedLengths,
    addedAccessories: state.addedAccessories
  };

  let cartObject = await getCartItemsObject()
  let cartObjectKeys = Object.keys(cartObject)
  cartObjectKeys = cartObjectKeys.length > 0 ? cartObjectKeys.map(v => parseInt(v)) : []


  let updates = {};
  Object.keys(formData.lineItems).forEach(patternKey => {
    Object.keys(formData.lineItems[patternKey])
    .filter(lengthKey => lengthKey !== 'product_id') // Filter out product_id
    .forEach(lengthKey => {
      // lineitems.push({
      //   // variant_id: parseInt(formData.lineItems[patternKey][lengthKey].variant_id),
      //   // quantity: formData.lineItems[patternKey][lengthKey].quantity,
      //   [parseInt(formData.lineItems[patternKey][lengthKey].variant_id)]: formData.lineItems[patternKey][lengthKey].quantity,
      // });
      if(cartObjectKeys.includes(parseInt(formData.lineItems[patternKey][lengthKey].variant_id))){
        updates[parseInt(formData.lineItems[patternKey][lengthKey].variant_id)] = formData.lineItems[patternKey][lengthKey].quantity + cartObject[parseInt(formData.lineItems[patternKey][lengthKey].variant_id)]
      }else{
        updates[parseInt(formData.lineItems[patternKey][lengthKey].variant_id)] = formData.lineItems[patternKey][lengthKey].quantity
      }
    });
  })
  formData.addedAccessories.forEach(acc => {
    // lineitems.push({
    //   // variant_id: parseInt(acc.variant_id),
    //   // quantity: acc.quantity,
    //   [parseInt(acc.variant_id)]: acc.quantity,
    // });
    if(cartObjectKeys.includes(parseInt(acc.variant_id))){
      updates[parseInt(acc.variant_id)] = acc.quantity + cartObject[parseInt(acc.variant_id)]
    }else{
      updates[parseInt(acc.variant_id)] = acc.quantity
    }
  });
  console.log('lineitems',updates)
  if(Object.keys(updates).length > 0){
    jQuery('.mainLoaderContainer').fadeIn(500)
    jQuery('html').css('overflow','hidden')
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data); // cart JSON
      jQuery('.mainLoaderContainer').fadeOut(500)
      jQuery('html').css('overflow','auto')
      resetAllSelections()
    })
    .catch((error) => {
      jQuery('.mainLoaderContainer').fadeOut(500)
      jQuery('html').css('overflow','auto')
      alert('Something went wrong while adding to cart, try again or contact support')
      console.error('Error:', error);
    });
  }
}
sidebarAddBtn.addEventListener("click", () => {
  if (sidebarAddBtn.disabled) return;

  // Validate cart requirements
  const validation = validateCartRequirements();
  
  if (!validation.valid) {
    // Show error message
    sidebarErrorEl.textContent = validation.message;
    sidebarErrorEl.style.color = "#d32f2f";
    sidebarErrorEl.style.marginBottom = "10px";
    return;
  }

  // Clear error message
  sidebarErrorEl.textContent = "";

  // Open checkout modal
  openCheckoutModal();
});
sidebarSaveBtn.addEventListener("click", () => {
  if (sidebarSaveBtn.disabled) return;

  // Validate cart requirements
  const validation = validateCartRequirements();
  
  if (!validation.valid) {
    // Show error message
    sidebarErrorEl.textContent = validation.message;
    sidebarErrorEl.style.color = "#d32f2f";
    sidebarErrorEl.style.marginBottom = "10px";
    return;
  }

  // Clear error message
  sidebarErrorEl.textContent = "";

  // Open checkout modal
  openSaveModal();
});
sidebarSaveAndContinueBtn.addEventListener("click", () => {
  if (sidebarSaveAndContinueBtn.disabled) return;

  // Validate cart requirements
  const validation = validateCartRequirements();
  
  if (!validation.valid) {
    // Show error message
    sidebarErrorEl.textContent = validation.message;
    sidebarErrorEl.style.color = "#d32f2f";
    sidebarErrorEl.style.marginBottom = "10px";
    return;
  }

  // Clear error message
  sidebarErrorEl.textContent = "";

  // add to cart
  addToCartAndContinue();
});

// Initial setup: apply derived selections and render everything
applyDerivedSelectionsFromStepIndex(-1);
renderAllSteps();
renderSidebar();

// Initialize checkout modal
createCheckoutModal();
createSaveModal();

// --- Sidebar visibility observer (show/hide visual card based on viewport) ---

const visualCard = document.querySelector(".visual-card");
const step2 = document.querySelector('[data-step="2"]');
const step3 = document.querySelector('[data-step="3"]');
const step4 = document.querySelector('[data-step="4"]');
const step5 = document.querySelector('[data-step="5"]');
function isAtTop(elem) {
  const rect = elem.getBoundingClientRect();
  return rect.top <= 250; // element touches top
}
if (visualCard && step3) {
  window.addEventListener('scroll', () => {
    if(step3 && isAtTop(step3)){
      visualCard.style.display = "none";
      // console.log("step 3 at top on load");
    }else{
      visualCard.style.display = "";
    }
  })
}